import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
// import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
// import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
// import { CustomLoaderService } from 'src/app/services/custom-loader.service';
// import { SummarydataService } from 'src/app/services/summarydata.service';
// import { TokenExpireService } from 'src/app/services/token-expire.service';
import { TransactionService } from 'src/app/services/transaction.service';
declare var $: any; import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
import { CustomLoaderService } from 'src/app/services/custom-loader.service';
import { DistributorOnboardingService } from 'src/app/services/distributor-onboarding.service';
import { ProfileService } from 'src/app/services/profile.service';
import { SummarydataService } from 'src/app/services/summarydata.service';
import { TokenExpireService } from 'src/app/services/token-expire.service';
import { isNullOrUndefined, NumberOnly } from 'src/app/validation';
import { environment } from 'src/environments/environment';
import { ReportService } from 'src/app/services/report.service';
import { text } from 'stream/consumers';
import { Router } from '@angular/router';
import { isArray } from 'highcharts';
import { Z_DATA_ERROR } from 'zlib';
import { faSliders, faTshirt } from '@fortawesome/free-solid-svg-icons';
import { DatePipe } from '@angular/common';
import { CleverTapUtilityService } from 'src/app/services/clever-tap-utility.service';
import { IPOServiceService } from 'src/app/services/iposervice.service';
declare var $: any;
declare var Razorpay: any;
declare var bootstrap: any; //Siddhesh_23072026
@Component({
  selector: 'app-payment-mode-popup',
  templateUrl: './payment-mode-popup.component.html',
  styleUrls: ['./payment-mode-popup.component.scss']
})
export class PaymentModePopupComponent implements OnInit, AfterViewInit {
  @ViewChild('mySelect') mySelect: ElementRef;
  Amount: any = '';
  UCCCode: any = '';
  ICCLAccountNo: any = environment.ICCLAccount;
  PaymentMode: FormGroup;
  paymentMethodSubscription: Subscription;
  selectedPaymentMethod = "";
  lumpsumBSEData: any;
  sipBSEData: any;
  cartServiceData: any;
  SelectedUCC: any;
  G_UserType: number;
  SelectedUCC_Text: any;
  G_UccCode: any;
  sipForm: any;
  mandateForm: any;
  ChequeForm: FormGroup;
  CVLClientCode: string;
  ClientTxStatusID: string;
  TxStatus: string;
  CVLValidatedCodes: any;
  ShowNote: boolean;
  OFS_Client: number;
  G_ClientBasicInfoId: any;
  IsFromClientSIP: string;
  IsClientAlreadySelected: boolean;
  ClientMandateListShow: []
  CustName: any;
  RazorCustId: string;
  AcccountNumber: String;
  TotalAmountPay: number;
  BankList: any;
  selectedOption: string; // Variable to hold the selected option
  NEFTRTGSForm: FormGroup;
  UPIForm: FormGroup;
  UPIFormSubmitted: boolean = false;
  AutoPayForm: FormGroup; fv
  FailureReason: any = "";
  ShowSuccessNEFTDetails: boolean;
  ShowFailureAutoPayDetails: boolean;
  ShowSuccessAutoPayDetails: boolean;
  ResponseMsg: string = "";

  SuccessChequeMessage: any = "";
  showChequeBankError: boolean = false;
  showChequeInputError: boolean = false;
  selectedChequeAccount: any;
  BankListCheque: any;

  RespmsgId: number = 1;
  PayableAmount: number = 0;
  LumsumOrderStatus: any[] = [];
  FinalOrderNo: any = "";
  OrderNo: any = "";
  OrderSuccessFlag: any[] = [];
  SuccessOrderNumber: any = [];
  cartIndex: number = 0;
  IsShowSuccessAndFail: boolean = false;
  IsShowSuccessAndFailAutoPay: boolean = false;
  @ViewChild('collapseTwo', { static: false }) collapseElement: any;
  @ViewChild('collapseOne', { static: false }) collapseElement1: any;
  @ViewChild('collapseThree', { static: false }) collapseElement3: any;
  @ViewChild('collapseUPI', { static: false }) collapseUPIElement3: any;
  @ViewChild('collapseseven', { static: false }) collapseElement7: any;
  @ViewChild('NEFTRTGSMain', { static: false }) NEFTRTGSMainElement: any;
  @ViewChild('AutoPayMain', { static: false }) AutoPayMainElement: any;
  @ViewChild('RazorPayMain', { static: false }) RazorPayMainElement: any;
  @ViewChild('UPIPayMain', { static: false }) UPIPayMainElement: any;
  ClientData: any;
  G_UCCCode: string;
  RazorPayUCC: string;
  ClientMobileNo: string;
  ClientEmailId: string;
  ClientName: string
  ClientMandateList: any;
  G_ROLEID: number = 0;
  SIPOrderNumber: any;
  NonFOTFlag: boolean = false;
  SuccessReason: any;
  isNEFTClickable: boolean = true;
  bsModelRef: BsModalRef<unknown>;
  counter: number = 0;
  selectedFruit: any;
  mandatedetails: any;
  orderId: any;
  selectedBankAccount: any;
  TempselectedPaymentMethod: string = "";
  MandateBank: string = "s";
  TransType_RazorPay: string;
  isShowAutoPay: boolean = true;
  Source: any;
  ShowBTNText: any = "";
  SelectedMandateCode: any;
  IsMobile: boolean = false;
  RazorPayCallBackURL: string = environment.RazorPayCallBackURL;
  rid: string = "";
  AutoPayDisable: boolean = false;
  disablePaymentgateway: boolean = false;
  NEFTPayClick: boolean = false;
  ChequeOrderStatus: boolean = true;
  HideChequeSuccessMessage: boolean = true;
  isShowPaymentModel: boolean = false;
  isTransactionForChallanInitiated: boolean = false;
  SBCodeForChallan: string;
  IFSCCode: string = "";  //SiddheshG_24072026
  BankCode: string = "";  //SiddheshG_24072026
  AcccountNumber_PG: String;


  constructor(private Loader: CustomLoaderService,
    private EncrdecrService: EncrdecrService,
    private distributorOnboardingService: DistributorOnboardingService,
    private summaryservice: SummarydataService,
    private clientProfileService: ProfileService,
    private Logout: TokenExpireService,
    private fb: FormBuilder,
    private transactionBSe: TransactionService,
    private bsModalRef: BsModalRef,
    private renderer: Renderer2,
    private router: Router
    , private bsModelService: BsModalService,
    private transaction: TransactionService, private reportservice: ReportService,
    private datePipe: DatePipe,
    private Clevertap: CleverTapUtilityService,
       private iposervice: IPOServiceService,
  ) {

    this.NEFTRTGSForm = this.fb.group({
      Bank: ['', [Validators.required]]
    });
    this.UPIForm = this.fb.group({
      Bank: ['', [Validators.required]],
      UPIID: ['', [Validators.required]],
    });

    this.ChequeForm = this.fb.group({
      CHEQUENO: ["", [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern(NumberOnly)]],
      chqDate: ["", Validators.required],
    });

  }
  ngOnInit() {

    if (
      sessionStorage.getItem("Hldq31TLYwRbLJ8") != null &&
      sessionStorage.getItem("Hldq31TLYwRbLJ8") != undefined) {
      this.SBCodeForChallan = this.EncrdecrService.getDecr(sessionStorage.getItem('Hldq31TLYwRbLJ8'));
    }
    console.log("SB Code : ", this.SBCodeForChallan);
    // Dynamically load Razorpay script after component initialization
    this.loadRazorpayScript().then(() => {
      console.log('Razorpay script loaded successfully');
    }).catch((error) => {
      console.error('Error loading Razorpay script:', error);
    });
    this.Loader.show();
    this.SetViewPort(window.innerWidth);
    this.cartServiceData = this.summaryservice.getSummaryData();
    console.log("Ng On init", this.cartServiceData);
    if (
      sessionStorage.getItem("5gE4QWzFXWKewRC") != null &&
      sessionStorage.getItem("5gE4QWzFXWKewRC") != undefined
    ) {
      this.G_ROLEID = parseInt(
        this.EncrdecrService.getDecr(
          sessionStorage.getItem("5gE4QWzFXWKewRC")
        )
      ); //Session_ROLEID
    }

    // if(sessionStorage.getItem("asjkldnakjeCheckCVLKRA")){
    //   this.CVLClientCode = sessionStorage.getItem("asjkldnakjeCheckCVLKRA")
    // }
    // if(sessionStorage.getItem("TxStatusIdCVLKRA")){
    //   this.ClientTxStatusID = sessionStorage.getItem("TxStatusIdCVLKRA")
    // }
    // if(!this.CVLValidatedCodes.includes(this.CVLClientCode) && (this.ClientTxStatusID=="1" || this.ClientTxStatusID=="2" || this.ClientTxStatusID=="13")){
    //   this.ShowNote = true
    // }
    // this.OFS_Client = parseInt(
    //   this.EncrdecrService.getDecr(
    //     sessionStorage.getItem("Abodhj#@jdkd/%^82ncdbcnggshd!@#$")
    //   )
    // );

    let tempClientBasicInfoId = sessionStorage.getItem("N1QJHdOkO7Hz8QC");
    if (
      tempClientBasicInfoId != null &&
      tempClientBasicInfoId != undefined
    ) {
      //this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(sessionStorage.getItem('UZT6qHaDZSz66kx')); //Session_ClientBasicInfoId
      this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(
        sessionStorage.getItem("N1QJHdOkO7Hz8QC")
      ); //Session_ClientBasicInfoId\
      // alert(this.G_ClientBasicInfoId)
      let IsClientSIP = sessionStorage.getItem("mgPecehdWotwEDw"); //Session_IsFromClientSIP
      if (IsClientSIP != null && IsClientSIP != undefined) {
        this.IsFromClientSIP = this.EncrdecrService.getDecr(
          sessionStorage.getItem("mgPecehdWotwEDw")
        ); //Session_IsFromClientSIP
      }

      if (
        this.G_ClientBasicInfoId != null &&
        this.G_ClientBasicInfoId != undefined
      ) {
        // this.sipForm.controls["ClientBasicInfoID"].setValue(
        //   parseInt(this.G_ClientBasicInfoId)
        // );
        //this.setSelectedClientUCC(this.G_ClientBasicInfoId);
        this.IsClientAlreadySelected = true;
        // if (this.G_UserType == 3) {
        //   this.setSelectedClientUCC(this.G_ClientBasicInfoId);
        // }
        if (this.G_UserType == 2) {
          sessionStorage.removeItem("N1QJHdOkO7Hz8QC"); //Session_ClientBasicInfoId
        }
      }
      if (!isNullOrUndefined(sessionStorage.getItem("asjkldnakje34234nwbes")) && sessionStorage.getItem("asjkldnakje34234nwbes") != "") {
        this.ClientData = JSON.parse(this.EncrdecrService.getDecr(sessionStorage.getItem("asjkldnakje34234nwbes")));
        console.log(this.ClientData);
      }
    }

    let UCCCode = "";
    if (!isNullOrUndefined(sessionStorage.getItem("sdochsidjcsdv")) && sessionStorage.getItem("sdochsidjcsdv") != "") {
      UCCCode = this.EncrdecrService.getDecr(sessionStorage.getItem("sdochsidjcsdv"));
      this.G_UccCode = UCCCode;
    }

    if (this.G_UserType == 3 && !isNullOrUndefined(sessionStorage.getItem("TF4q3aPcsYpaEDoa4ROM")) && sessionStorage.getItem("TF4q3aPcsYpaEDoa4ROM") != "") {
      this.TxStatus = this.EncrdecrService.getDecr(sessionStorage.getItem("TF4q3aPcsYpaEDoa4ROM"));
    }

    this.rid = sessionStorage.getItem("RequestID");
    if (this.rid == null) {
      this.rid = "";
    }

    this.RazorPayUCC = UCCCode;
    this.Loader.show();
    this.getClientMandateList(UCCCode);
    this.BindBankList(UCCCode);
    this.BindBankListCheque(UCCCode);
    // this.Loader.hide();

    sessionStorage.removeItem("RequestID");
  }
  loadRazorpayScript(): Promise<any> {
    return new Promise((resolve, reject) => {
      if ((window as any).Razorpay) {
        // Razorpay script already loaded, resolve immediately
        resolve((window as any).Razorpay);
      } else {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.onload = () => resolve((window as any).Razorpay); // Using type assertion here
        script.onerror = (error) => reject(error);
        document.body.appendChild(script);
      }
    });
  }
  get u() {
    return this.UPIForm.controls;
  }
  get c() {
    return this.ChequeForm.controls;
  }

  ngAfterViewInit() {


    $(document).on('wheel', function () {
      $('.datepicker-dropdown').hide();
    });


    $(document).on('focus', '.datepicker-input', function () {
      $(this).datepicker('show');
    });


    $(document).on('click', '.datepicker-input', function () {
      $(this).datepicker('show');
    });

    $(document).on('click', '.clsDatePickerChequeDate', function () {
      $(this).datepicker('show');
    });

    $('select').select2();
    // $(".CustomSelect").on("change", (e: any) =>
    //   this.NEFTRTGSForm.controls["Bank"].setValue(e.target.value)
    // );
    $(".CustomSelect").on("change", (e: any) => this.SelectedPaymentMode(e));
    $(".CustomSelectBank").on("change", (e: any) => this.SelectedBank_Direct(e));
    $(".CustomSelectBank_UPI").on("change", (e: any) => this.SelectedBank_Direct_UPI(e));
    
    $(".CustomSelectChequeBank").on("change", (e: any) => this.SelectedBank_Direct(e, 'Cheque'));
    $(".CustomSelectMandateCode").on("change", (e: any) => this.SelectedMandateId_Direct(e));

    // For Cheque Date
    $(".clsDatePickerChequeDate").datepicker({
      autoclose: true,
      endDate: '+0d',
      format: "dd/mm/yyyy",
      todayBtn: 'linked',
      todayHighlight: true,
      orientation: "top right",
      startDate: "-74d",
    }).on('change', (e: any) => this.ChequeForm.controls['chqDate'].setValue(e.target.value));

  }

  validateManualDate(inputVal: string) {
    if (!inputVal || inputVal.length < 10) {
      this.ChequeForm.controls['chqDate'].setErrors({ 'invalidDate': true });
      return true;
    }

    const parts = inputVal.split('/');
    const inputDay = parseInt(parts[0], 10);
    const inputMonth = parseInt(parts[1], 10);
    const inputYear = parseInt(parts[2], 10);

    const selectedDate = new Date(inputYear, inputMonth - 1, inputDay);

    if (selectedDate.getFullYear() !== inputYear ||
      selectedDate.getMonth() !== (inputMonth - 1) ||
      selectedDate.getDate() !== inputDay) {
      this.ChequeForm.controls['chqDate'].setErrors({ 'invalidDate': true });
      return true;
    }

    selectedDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const minDate = new Date();
    minDate.setDate(today.getDate() - 74);
    minDate.setHours(0, 0, 0, 0);

    if (isNaN(selectedDate.getTime()) || selectedDate < minDate || selectedDate > today) {
      this.ChequeForm.controls['chqDate'].setErrors({ 'invalidRange': true });
      return true;
    } else {
      this.ChequeForm.controls['chqDate'].setErrors(null);
      return false;
    }
  }

  formatDate(e: any, num) {
    var charCode = e.which ? e.which : e.keyCode;
    let date = e.target.value;

    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
      return false;
    } else {
      if (date.length == 2) {
        date = date + "/";
        this.ChequeForm.controls['chqDate'].setValue(date);
      }
    }
    if (date.length == 5) {
      date = date + "/";
      this.ChequeForm.controls['chqDate'].setValue(date);
    }
    return true;

  }

  CheckDate(e: any, num: number) {
    debugger
    let date = e.target.value;
    let tempdate = new Date();
    const y = tempdate.getFullYear();
    console.log(y)

    if (date.length == 10) {
      let tepDate = date.split("/");
      if (tepDate[1] > 12 || tepDate[0] > 31 || tepDate[2] > y) {
        debugger
        this.ChequeForm.controls['chqDate'].setValue("");

      }
    }
  }

  OnChangeInvestedAmount(event) {
    const charCode = event.which ? event.which : event.keyCode;
    let a = this.ChequeForm.controls.CHEQUENO.value;

  }

  ValidatePattern(flag, e) {
    if (flag == "Number") {
      const charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }
    else if (flag == "NumberWithSlash") {
      const charCode = e.which ? e.which : e.keyCode;
      if (charCode == 47) {
        return true;
      }
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      else {

      }
      return true;
    }
    else if (flag == "NumberandCharc") {
      const k = e.which ? e.which : e.keyCode;
      return (
        (k > 64 && k < 91) ||
        (k > 96 && k < 123) ||
        k == 8 ||
        k == 32 ||
        (k >= 48 && k <= 57)
      );
    }
  }

  OnPaste(e) {
    e.preventDefault();
  }
  OnDrop(e) {
    e.preventDefault();
  }


  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    }
    else {
      this.IsMobile = false;
    }
  }

  GetUCCCode(cbid) {
    this.transaction.GetClientUCCDetails(cbid).then(
      (response: any) => {
        let res = JSON.parse(this.EncrdecrService.getDecr(response))
        if (res != null) {
          if (
            res.Message != null &&
            res.Message != "" &&
            res.Message.indexOf("Not Authorized") > -1
          ) {
            this.Loader.hide();
            this.Logout.LogoutUser();
            return;
          } else {
            if (res.ArrayOfResponse.length > 0) {
              this.G_UCCCode = res.ArrayOfResponse[0].ClientCode;
              if (this.OFS_Client == 4) {
                this.Loader.show();
                this.Loader.show();
                this.clientProfileService
                  .GetClientInfo(this.G_ClientBasicInfoId)
                  .then(
                    (response: any) => {
                      let res = JSON.parse(this.EncrdecrService.getDecr(response))
                      if (res != null) {
                        if (
                          res.Message != null &&
                          res.Message != "" &&
                          res.Message.indexOf("Not Authorized") > -1
                        ) {
                          this.Loader.hide();
                          this.Logout.LogoutUser();
                          return;
                        } else {
                          let BasicDetails =
                            res.ArrayOfResponse[0].personalDetails[0].active[0]
                              .firstApplicant[0];
                          // this.Investorname = BasicDetails.Investorname;
                          // this.ClientPanNo = this.EncrdecrService.getDecr(
                          //   BasicDetails.panno
                          // );
                          this.CustName = this.EncrdecrService.getDecr(
                            BasicDetails.FirstName
                          );
                          this.ClientMobileNo = this.EncrdecrService.getDecr(
                            BasicDetails.Mobno
                          );
                          if (
                            BasicDetails.emailid != null &&
                            BasicDetails.emailid != undefined &&
                            BasicDetails.emailid != ""
                          )
                            this.ClientEmailId = this.EncrdecrService.getDecr(
                              BasicDetails.emailid
                            );
                        }
                      }
                      this.Loader.hide();
                    },
                    (err) => {
                      this.Loader.hide();
                    }
                  );
                this.Loader.hide();
              }
            } else {
              this.G_UCCCode = "0";
              const Client = parseInt(
                this.EncrdecrService.getDecr(
                  sessionStorage.getItem("Abodhj#@jdkd/%^82ncdbcnggshd!@#$")
                )
              );

              this.Loader.hide();

            }
          }
        }
      },
      (err) => { }
    );
  }

  SelectedPaymentMode(e) {
    this.selectedPaymentMethod = e.target.value;
    console.log("Selected paymentmethod: " + this.selectedPaymentMethod);
    // if(this.selectedPaymentMethod.includes("NEFT")){
    //   $("#NEFTModal").removeClass("d-none");
    //   $("#NEFTModal").addClass("d-block");
    //   $(".ClsTransactionOTPModel").addClass("d-none");
    // }
  }
  onClickDismissButton() {
    this.bsModalRef.hide();
  }

  //After Submit LUMPSUM BSE Process (Final API CALL)
  LumpSumBseProcess() {
    debugger
    this.TransType_RazorPay = "Lumpsum";
    console.log("Bse Lumpsum", this.lumpsumBSEData);
    if (this.lumpsumBSEData.Flag == "FromOrderBookReport") {
      this.Source = this.lumpsumBSEData.Flag;
      this.ShowBTNText = "Okay";
    }
    else {
      this.Source = "";
      this.ShowBTNText = "Go to Order Book"
    }
    // Dynamic key to be added
    let newKey = 'PaymentType';
    let newValue = this.selectedPaymentMethod;
    let newKey2 = 'OTMMandateId';
    //let newKey3 = 'mandateBank';
    let newValue2: any;
    //let newValue3 : any;
    if (this.selectedPaymentMethod == "AutoPay") {
      newValue2 = this.SelectedMandateCode;
      //newValue3 = this.MandateBank;
    }
    else {
      newValue2 = "";
      // newValue3 = "";
    }

    // Add the key-value pair dynamically
    this.lumpsumBSEData[newKey] = newValue;
    this.lumpsumBSEData[newKey2] = newValue2;
    console.log("Updated cart", this.lumpsumBSEData);
    //Added by Tishya for RazorPay Prefill data
    this.ClientName = this.lumpsumBSEData.ClientName.split('-')[0].trim(),
      this.ClientEmailId = this.lumpsumBSEData.EmailId,
      this.ClientMobileNo = this.lumpsumBSEData.MobileNumber

    this.lumpsumBSEData["Cheque"] = this.ChequeForm.controls["CHEQUENO"].value ?? "";
    this.lumpsumBSEData["ChequeDate"] = this.ChequeForm.controls["chqDate"].value ?? "";
    //Added by Tishya for RazorPay Prefill data
    console.log("Client Details:", this.ClientName + " " + this.ClientEmailId + " " + this.ClientMobileNo);

    debugger
    this.Loader.show();
    if (this.lumpsumBSEData.Flag == "FromOrderBookReport") {
      this.lumpsumBSEData.UccCode = this.lumpsumBSEData.ClientCode;
      this.lumpsumBSEData.TransactionValidation = this.EncrdecrService.setEncr(
        this.lumpsumBSEData.SchemeCode +
        "|" +
        this.lumpsumBSEData.Amount
      );
      this.lumpsumBSEData.Amount = this.EncrdecrService.setEncr(this.lumpsumBSEData.Amount);
      this.lumpsumBSEData.FolioNumber = this.lumpsumBSEData.FolioNo;
      // this.lumpsumBSEData.FromScheme = this.lumpsumBSEData.SchemeCode;
      this.lumpsumBSEData.BSESchemeCode = this.lumpsumBSEData.SchemeCode;
      this.lumpsumBSEData.isReinitiated = 0; //Added By Devang Mehta On 13-02-2025
      this.lumpsumBSEData.TransactionId = this.lumpsumBSEData.Tran_Id; //Added By Devang Mehta On 13-02-2025

    }
    this.transactionBSe
      .InvestToLumpsum(this.lumpsumBSEData,
        this.rid,
        this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX')),
        this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL")))
      .subscribe((response: any) => {
        debugger
        let result = JSON.parse(this.EncrdecrService.getDecr(response));
        let orderno = result.OrderNo
        if (result != null) {
          if (
            result.Message != null &&
            result.Message != "" &&
            result.Message.indexOf("Not Authorized") > -1
          ) {
            this.Loader.hide();
            this.Logout.LogoutUser();
            return;
          } else {
            if (result.SuccessFlag == 0) {
              console.log("BSE Response " + JSON.stringify(result));
              //this.CallAlertModal(result.Message);
              if (this.lumpsumBSEData.G_UserType == 3) {
                this.Loader.hide();
                if (this.selectedPaymentMethod == "NEFT/RTGS") {
                  this.Amount = this.EncrdecrService.getDecr(this.lumpsumBSEData.Amount);
                  this.UCCCode = this.lumpsumBSEData.UccCode;
                  this.ShowSuccessNEFTDetails = true;
                  if (this.collapseElement) {
                    this.renderer.removeClass(this.collapseElement.nativeElement, 'collapse'); // Remove the 'collapse' class
                    this.renderer.addClass(this.collapseElement.nativeElement, 'show');  // Add the 'show' class to expand it
                    // this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabledAfterPayment');

                  }
                }
                if (this.selectedPaymentMethod == "AutoPay") {
                  this.IsShowSuccessAndFailAutoPay = false
                  this.FailureReason = "Orders initiated successfully";
                  this.CallSuccessFailAlertModal("Orders initiated successfully");
                }
                if (this.selectedPaymentMethod == "PaymentGateway" || this.selectedPaymentMethod == "UPI" ) {
                  this.PayableAmount = parseInt(this.EncrdecrService.getDecr(this.lumpsumBSEData.Amount));
                  //this.RazorPayCallToCreateOrder(this.lumpsumBSEData.PaymentReferenceID); //siddhesh_26072026
                  this.GetNetBankingPageIncred(result.FinalOrderNo, this.PayableAmount, this.selectedPaymentMethod , this.UPIForm.controls["UPIID"].value, this.lumpsumBSEData.UccCode);
                }
                if (this.selectedPaymentMethod == 'CHEQUE') {

                  this.PayableAmount = parseInt(this.EncrdecrService.getDecr(this.lumpsumBSEData.Amount));
                  this.UCCCode = this.lumpsumBSEData.UccCode;

                  this.SendReqForChallan(result.OrderNo, this.PayableAmount, this.UCCCode);

                }

              } else {
                this.Loader.hide();
                this.FailModal(
                  "Transaction has been initiated successfully. Payment link sent on client registered email Id, client needs to make the payment using the link received in email."
                );
              }
              this.SendMail("LumpsumBSE", result, this.lumpsumBSEData.CreatedBy, this.lumpsumBSEData.UserType);
            } else if (result.SuccessFlag == 1) {
              //this.ClearAll();
              this.Loader.hide();
              this.ShowSuccessNEFTDetails = false;
              this.FailureReason = result.Message;
              if (this.selectedPaymentMethod == "NEFT/RTGS") {
                if (this.collapseElement) {
                  this.renderer.removeClass(this.collapseElement.nativeElement, 'collapse'); // Remove the 'collapse' class
                  this.renderer.addClass(this.collapseElement.nativeElement, 'show');  // Add the 'show' class to expand it
                  // this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabledAfterPayment');
                }
              } if (this.selectedPaymentMethod == "AutoPay") {
                this.IsShowSuccessAndFailAutoPay = true;
                // this.CallAlertModal(result.Message);
                this.CallSuccessFailAlertModal(result.Message);
              }
              if (this.selectedPaymentMethod == "PaymentGateway" || this.selectedPaymentMethod == "UPI") {
                this.CallSuccessFailAlertModal(result.Message);
              }
              if (this.selectedPaymentMethod == "CHEQUE") {
                this.CallSuccessFailAlertModal(result.Message);
              }
              // this.SendRejectedMail("LumpsumBSE", result.Message);
              this.SendRejectedMail("LumpsumBSE", result, this.lumpsumBSEData.CreatedBy, this.lumpsumBSEData.UserType);
            } else {
              this.Loader.hide();
              //this.ClearAll();
              this.FailModal(
                "There seems to be some issue. Please try again later."
              );
            }
          }
        }
      });
  }

  SipBseProcess() {
    this.TransType_RazorPay = "SIP";
    console.log(this.sipBSEData);
    if (this.sipBSEData.Flag == "FromOrderBookReport") {
      this.ShowBTNText = "Okay";
      this.Source = this.sipBSEData.Flag;
    }
    else {
      this.Source = "";
      this.ShowBTNText = "Go to Order Book"
    }
    let newKey = 'PaymentType';
    let newValue = this.selectedPaymentMethod;
    let newKey2 = 'OTMMandateId';
    //let newKey3 = "mandatebank";
    //let newValue3 : any ;
    let newValue2: any;
    if (this.selectedPaymentMethod == "AutoPay") {
      newValue2 = this.SelectedMandateCode;
      //newValue3 = this.MandateBank;
    }
    else {
      newValue2 = "";
      // newValue3 = null;
    }
    // Add the key-value pair dynamically
    this.sipBSEData[newKey] = newValue;
    this.sipBSEData[newKey2] = newValue2;
    console.log("Updated cart", this.sipBSEData);
    //Added by Tishya for RazorPay Prefill data
    this.ClientName = this.sipBSEData.ClientName.split('-')[0].trim(),
      this.ClientEmailId = this.sipBSEData.EmailId,
      this.ClientMobileNo = this.sipBSEData.MobileNumber
    //Added by Tishya for RazorPay Prefill data

    this.sipBSEData["Cheque"] = this.ChequeForm.controls["CHEQUENO"].value ?? "";
    this.sipBSEData["ChequeDate"] = this.ChequeForm.controls["chqDate"].value ?? "";

    console.log("Client Details:", this.ClientName + " " + this.ClientEmailId + " " + this.ClientMobileNo);

    console.log("SIPBSEData: " + JSON.stringify(this.sipBSEData));

    //Added By Devang Mehta On 12-02-2025
    if (this.sipBSEData.Flag == "FromOrderBookReport") {
      this.sipBSEData.UccCode = this.sipBSEData.ClientCode;
      this.sipBSEData.TransactionValidation = this.EncrdecrService.setEncr(
        this.sipBSEData.SchemeCode +
        "|" +
        this.sipBSEData.Amount
      );
      this.sipBSEData.Amount = this.EncrdecrService.setEncr(this.sipBSEData.Amount);
      this.sipBSEData.FolioNumber = this.sipBSEData.FolioNo;
      // this.sipBSEData.FromScheme = this.sipBSEData.SchemeCode;
      this.sipBSEData.BSESchemeCode = this.sipBSEData.SchemeCode;
      this.sipBSEData.Frequency = this.sipBSEData.SIPFrequency;
      this.sipBSEData.FirstOrderFlag = this.sipBSEData.FirstOrder;
      this.sipBSEData.SIPMode = 'ESIP';
      this.sipBSEData.MandateCode = this.sipBSEData.MandateID;
      this.sipBSEData.isReinitiated = 0; //Added By Devang Mehta On 13-02-2025
      this.sipBSEData.TransactionId = this.sipBSEData.Tran_Id; //Added By Devang Mehta On 13-02-2025
    }
    //End By Devang Mehta

    this.transactionBSe
      .InvestToSIP(this.sipBSEData,
        this.rid,
        this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX')),
        this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL")))
      .subscribe((response: any) => {
        //this.CallAlertModal(JSON.stringify(result));
        debugger;
        this.Loader.hide();
        let result = JSON.parse(this.EncrdecrService.getDecr(response));
        if (result != null) {
          if (
            result.Message != null &&
            result.Message != "" &&
            result.Message.indexOf("Not Authorized") > -1
          ) {
            this.Loader.hide();
            this.Logout.LogoutUser();
            return;
          } else {
            if (result.SuccessFlag == 0) {
              if (this.sipBSEData.G_UserType == 3) {
                if (this.sipBSEData.FirstOrderFlag == "Y") {
                  this.Loader.hide();
                  if (this.selectedPaymentMethod == "NEFT/RTGS") {
                    this.Amount = this.EncrdecrService.getDecr(this.sipBSEData.Amount);
                    this.UCCCode = this.sipBSEData.UccCode;
                    this.ShowSuccessNEFTDetails = true;
                    if (this.collapseElement) {
                      this.renderer.removeClass(this.collapseElement.nativeElement, 'collapse'); // Remove the 'collapse' class
                      this.renderer.addClass(this.collapseElement.nativeElement, 'show');  // Add the 'show' class to expand it
                      // this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabledAfterPayment');
                    }
                  }
                  if (this.selectedPaymentMethod == 'AutoPay') {
                    this.CallSuccessFailAlertModal("Orders initiated successfully");
                  }
                  if (this.selectedPaymentMethod == "PaymentGateway" || this.selectedPaymentMethod == "UPI") {
                    this.PayableAmount = parseInt(this.EncrdecrService.getDecr(this.sipBSEData.Amount));
                    //this.RazorPayCallToCreateOrder(this.sipBSEData.PaymentReferenceID);  //Siddhesh_21072026
                    this.GetNetBankingPageIncred(result.FinalOrderNo, this.PayableAmount, this.selectedPaymentMethod , this.UPIForm.controls["UPIID"].value, this.sipBSEData.UccCode);
                  }
                  if (this.selectedPaymentMethod == 'CHEQUE') {

                    this.PayableAmount = parseInt(this.EncrdecrService.getDecr(this.sipBSEData.Amount));
                    this.UCCCode = this.sipBSEData.UccCode;

                    this.SendReqForChallan(result.FinalOrderNo, this.PayableAmount, this.UCCCode);

                  }
                } else {
                  if (this.selectedPaymentMethod == "NEFT/RTGS") {
                    this.Loader.hide();
                    this.NonFOTFlag = true;
                    this.SuccessReason = result.Message;
                    if (this.collapseElement) {
                      this.renderer.removeClass(this.collapseElement.nativeElement, 'collapse'); // Remove the 'collapse' class
                      this.renderer.addClass(this.collapseElement.nativeElement, 'show');  // Add the 'show' class to expand it
                      // this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabledAfterPayment');
                    }
                  }
                  if (this.selectedPaymentMethod == 'AutoPay') {
                    this.CallSuccessFailAlertModal(result.Message);
                  }
                  if (this.selectedPaymentMethod == "PaymentGateway" || this.selectedPaymentMethod == "UPI") {
                    //this.RazorPayCallToCreateOrder(this.sipBSEData.PaymentReferenceID);  //Siddhesh_23072026
                    this.GetNetBankingPageIncred(result.FinalOrderNo, this.PayableAmount, this.selectedPaymentMethod , this.UPIForm.controls["UPIID"].value, this.sipBSEData.UccCode);
                  }
                  if (this.selectedPaymentMethod == 'CHEQUE') {

                    this.PayableAmount = parseInt(this.EncrdecrService.getDecr(this.sipBSEData.Amount));
                    this.UCCCode = this.sipBSEData.UccCode;

                    this.SendReqForChallan(this.OrderNo, this.PayableAmount, this.UCCCode);

                  }
                }
              } else {
                this.Loader.hide();
                if (this.sipBSEData.FirstOrderFlag == 'N') {
                  this.FailModal("Transaction has been initiated successfully.")
                }
                else {
                  this.FailModal(
                    "Transaction has been initiated successfully.Payment link sent on client registered email Id, client needs to make the payment using the link received in email."
                  );
                }
              }

              this.SendMail("SIPBse", result, this.sipBSEData.CreatedBy, this.sipBSEData.UserType);
              //this.ClearAll();

              //this.sipForm.reset();
            } else if (result.SuccessFlag == 1) {
              this.Loader.hide();
              this.ShowSuccessNEFTDetails = false;
              this.FailureReason = result.Message;
              if (this.selectedPaymentMethod == "NEFT/RTGS") {
                if (this.collapseElement) {
                  this.renderer.removeClass(this.collapseElement.nativeElement, 'collapse'); // Remove the 'collapse' class
                  this.renderer.addClass(this.collapseElement.nativeElement, 'show');  // Add the 'show' class to expand it
                  // this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabledAfterPayment');
                }
                console.log("BSE SIP Log Message " + result.Message);
              }
              if (this.selectedPaymentMethod == "AutoPay") {
                this.CallSuccessFailAlertModal(result.Message)
              }
              if (this.selectedPaymentMethod == "PaymentGateway"|| this.selectedPaymentMethod == "UPI") {
                this.CallSuccessFailAlertModal(result.Message)
              }
              if (this.selectedPaymentMethod == "CHEQUE") {
                this.CallSuccessFailAlertModal(result.Message);
              }
              this.SendRejectedMail("SIPBSE", result, this.sipBSEData.CreatedBy, this.sipBSEData.UserType);
              //this.ClearAll();
              // this.Loader.hide();

              // var msg =
              //   !isNullOrUndefined(result.Message) && result.Message != ""
              //     ? result.Message
              //     : "There seems to be some issue, please try again later.";
              // this.FailModal(msg);
              //#region  old code
              // if (result.Message.includes('Mandate Amount Exhausted')) {
              //   this.CallAlertModal('Sorry! Your mandate amount set has been exhausted for this date. Please try selecting some other date.');
              // }
              // else if (result.Message.includes('Order Entry not allowed in the scheme')) {
              //   this.CallAlertModal('Sorry! Invalid scheme. Please check and select correct scheme.');
              // }
              // else if (result.Message.includes('ELOG/Image not verified by')) {
              //   this.CallAlertModal('Sorry! Your MF account opening form is not verified. Please contact your Branch / RM.');
              // }
              // else if (result.Message.includes('ORDER AMT IS LESS THAN MINIMUM SPECIFIED')) {
              //   this.CallAlertModal('Alert! The amount entered is less than the minimum amount specified for this scheme. Please enter a valid amount.');
              // }
              // else if (result.Message.includes('ORDER AMT IS MORE THAN MAX VALUE SPECIFIED')) {
              //   this.CallAlertModal('Alert! The amount entered is more than the maximum amount specified for this scheme. Please enter a valid amount.');
              // }
              // else if (result.Message.includes('ORDER AMT IS MORE THAN MAX VALUE SPECIFIED')) {
              //   this.CallAlertModal('Alert! The amount entered is more than the maximum amount specified for this scheme. Please enter a valid amount.');
              // } else {
              //   this.FailModal('There seems to be some issue. Please try again later.');
              // }
              //#endregion
            } else {
              this.Loader.hide();
              this.FailModal(
                "There seems to be some issue. Please try again later."
              );
              //this.ClearAll();
            }
          }
        }
        this.Loader.hide();
      });
  }

  FailModal(msg: any) {
    $("#failBSEAlertModal").modal({ backdrop: "static", keyboard: false });
    $("#FailBSEAlertModalContent").text(msg);
  }

  BindBankList(UccCode: any) {
    debugger
    this.clientProfileService.getBankListForPaymentModal(UccCode).then((data_res: any) => {
      let res = JSON.parse(this.EncrdecrService.getDecr(data_res));
      console.log("Bind bank", res);

      debugger
      if (res != null) {
        if (
          res.Message != null &&
          res.Message != "" &&
          res.Message.indexOf("Not Authorized") > -1
        ) {
          this.Loader.hide();
          this.Logout.LogoutUser();
          return;
        } else {
          this.BankList = res.ArrayOfResponse;
          console.log("Bank list", this.BankList);
          if(this.BankList.length >0)
          {
  this.IFSCCode = this.BankList[0].VALUEFIELD;  //Siddhesh_24072026_IFSC_code handing
      this.BankCode = this.BankList[0].USER_CODE;  //Siddhesh_24072026_IFSC_code handing  
      this.AcccountNumber_PG = this.BankList[0].TEXTFIELD.split('|')[0];
          }
          this.SelectedBank(this.BankList[0].TEXTFIELD)

        }
      }
    });
  }

  BindBankListCheque(UCCCode) {
    this.clientProfileService.getBankListForPaymentModalCheque(UCCCode).then((data_res: any) => {
      let res = JSON.parse(this.EncrdecrService.getDecr(data_res));
      console.log("Bind bank", res);

      debugger
      if (res != null) {
        if (
          res.Message != null &&
          res.Message != "" &&
          res.Message.indexOf("Not Authorized") > -1
        ) {
          this.Loader.hide();
          this.Logout.LogoutUser();
          return;
        } else {
          this.BankListCheque = res.ArrayOfResponse;

          // this.BankListCheque =[{"TEXTFIELD" : "684536184120|HDFC0000358|Smit Test|HDFC BANK|HDF", "VALUEFIELD" : "HDFC0000358"},{"TEXTFIELD" : "8746787|HDFC0000358|Smit Test|HDFC BANK|HDF", "VALUEFIELD" : "HDFC0000358"}]

          console.log("Bank list", this.BankListCheque);
          // this.SelectedBank(this.BankList[0].TEXTFIELD)
        }
      }
    });
  }

  RedirectToDashBoard(arg0: string) {
    throw new Error('Method not implemented.');
  }

  getClientMandateList(UccCode: any) {
    debugger
    this.ClientMandateList = [];
    this.Loader.show();
    try {
      this.reportservice
        .getClientMandatelist_OTMPayment("0", UccCode, 0, 0, "Select", this.G_ROLEID.toString(), this.rid, this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX')),
          "3", this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL")))
        .subscribe((response) => {
          let data = JSON.parse(this.EncrdecrService.getDecr(response))
          console.log("mandate list", data);
          debugger
          if (data != null) {
            if (data.ArrayOfResponse.length > 0) {
              this.Loader.hide();
              this.isShowAutoPay = true;
              data.ArrayOfResponse.map(a => {
                let d = a.ManEndDate;
                if (d != null && d != '') {
                  a.ManEndDate = d.split('T')[0];
                }
                a.ShowMandate = `${a.ResponseMandateId}/${a.Amount}/${a.BankName} - ${a.AccountNo
                  }/${a.STATUS}`; //${a.ManEndDate}/
                this.ClientMandateList.push(a)
              });
              console.log("Mandate list", this.ClientMandateList);
              this.mandatedetails = this.ClientMandateList[0];
              this.SelectedMandateId(this.ClientMandateList[0].ResponseMandateId)

              // let v = this.mandateForm.controls["MandateType"].value;
              // if (v != '' && v != null && v != undefined) {
              //   this.SetMandate(v);
              // }
              // else {
              //   this.Loader.hide();
              // }
            } else {
              this.isShowAutoPay = false;
              this.Loader.hide();
              this.ClientMandateListShow = [];
            }
          }
        });
    }
    catch (err) {
      console.log(err)
      this.Loader.hide()
    }
  }
  onChangeSchemeSIP(product_code: any) {
    throw new Error('Method not implemented.');
  }

  // RazorPayCall() {
  //   //use4 to create the customer in razor pay with this values
  //   let obj = {
  //     "name": this.CustName,
  //     "email": this.ClientEmailId,
  //     "contact": this.ClientMobileNo,
  //     "fail_existing": "1",
  //     "gstin": null,
  //     "notes": {
  //       "notes_key_1": "",
  //       "notes_key_2": ""
  //     }
  //   }
  //   let JsonStr = JSON.stringify(obj);
  //   //will take from some api call right now doing hardcoded
  //   // this.RazorCustId = "cut_P1mCOJFan28igUW";
  //   this.RazorCustId = "cust_PV2mDBMdI0GirP";


  //   this.distributorOnboardingService.CreateCustomerRazorPay({}, this.G_ClientBasicInfoId, this.AcccountNumber, JsonStr, this.TotalAmountPay, this.RazorCustId).subscribe(
  //     (res: any) => {
  //       if (res != null) {
  //         debugger
  //         const options: any = {
  //           key: environment.RazorPayKey,
  //           amount: 100,
  //           //this.EncrdecrService.getDecr(this.cartServiceData.Amount), //dynaminc)z 
  //           currency: 'INR', //static
  //           name: this.cartServiceData.SIPMode,//'Test', //ask sir 
  //           description: 'Test Transaction', //ask sir
  //           image: 'https://yourlogo.com/logo.png',
  //           order_id: res.lstCustOrdRes[0].id,
  //           prefill: {
  //             name: this.CustName, // use Session to get details
  //             email:"dalsukh@gmail.com" ,//this.ClientEmailId,//,// use Session to get details
  //             contact: '9978654875'//this.ClientMobileNo//,// use Session to get details
  //           },
  //           theme: {
  //             color: '#F37254',
  //           },
  //         };

  //         options.handler = ((response, error) => {
  //           debugger
  //           //this.PaymentCheck(response);
  //         });

  //         // const razorpay = new (window as any).Razorpay(options);
  //         const razorpay = new (window as any).Razorpay(options);
  //         razorpay.open();

  //       }
  //     },
  //     (err: any) => {
  //       this.Loader.hide();
  //     }
  //   );
  // }
  SelectedBank(e) {
    this.selectedBankAccount = e;
    console.log("Selected bank: " + this.selectedBankAccount);
  }
  SelectedBank_Direct(e, flag: any = "") {
    debugger;
    this.selectedBankAccount = e.target.value;

    if (flag == "Cheque") {
      this.selectedChequeAccount = e.target.value;
      this.showChequeBankError = false;
    }

    console.log("Selected bank direct: " + this.selectedBankAccount);
    this.SelectedBank(this.selectedBankAccount);
   
  }
   SelectedBank_Direct_UPI(e, flag: any = "") {
    debugger;
    this.selectedBankAccount = e.target.value;
this.UPIForm.controls["Bank"].setValue(null);
    if (flag == "Cheque") {
      this.selectedChequeAccount = e.target.value;
      this.showChequeBankError = false;
    }

    console.log("Selected bank direct: " + this.selectedBankAccount);
    this.SelectedBank(this.selectedBankAccount);
    const SelectedBank = this.BankList.filter(
      (row: any) => row.TEXTFIELD == this.selectedBankAccount
    );
    if (SelectedBank != null && SelectedBank != undefined) {
      this.IFSCCode = SelectedBank[0].VALUEFIELD;  //Siddhesh_24072026_IFSC_code handing
      this.BankCode = SelectedBank[0].USER_CODE;  //Siddhesh_24072026_IFSC_code handing  
      this.AcccountNumber_PG = SelectedBank[0].TEXTFIELD.split('|')[0];
      this.UPIForm.controls["Bank"].setValue(this.selectedBankAccount);
    }
  }
  SelectedMandateId(e) {
    this.SelectedMandateCode = e;
    console.log("Selected mandate id", + this.SelectedMandateCode);

    this.mandatedetails = [];

    this.mandatedetails = this.ClientMandateList.filter(d => d.ResponseMandateId == this.SelectedMandateCode);

    // this.mandatedetails.array.forEach(element => {
    //   if(element.ResponseMandateId == e)
    //     {
    //       this.MandateBank = element.ShowMandate.toString().split('/')[2] ;
    //     }
    // });

  }
  SelectedMandateId_Direct(e) {
    this.SelectedMandateCode = e.target.value;
    console.log("Selected Mandate id direct:" + this.SelectedMandateCode);
    this.SelectedMandateId(this.SelectedMandateCode);
  }
  RazorPayCallToCreateOrder(PaymentReferenceID) {
    debugger;
    let currentdate = new Date();
    let dt = this.datePipe.transform(currentdate, 'ddMMyyHHmmss');
    let bankaccount = this.selectedBankAccount.split('|');
    console.log("Selected bank: " + this.selectedBankAccount);
    console.log("Bank Account: " + bankaccount);
    let json = {
      "amount": (this.PayableAmount * 100),//convert to paisa,   
      "receipt": PaymentReferenceID,//"//"BILL13375649",
      "currency": "INR",
      "UCCCode": this.RazorPayUCC,
      "PurchaseTransactionMode": this.TransType_RazorPay,
      "bank_account": {
        "account_number": bankaccount[0],//"765432123456789",
        "name": bankaccount[2],//"Gaurav Kumar",
        "ifsc": bankaccount[1],//"HDFC0000053" 
      }
    }

    let JsonStr = JSON.stringify(json);
    console.log(JsonStr);
    this.Loader.show();
    this.distributorOnboardingService.CreateCustomerRazorPayTPV("", JsonStr, this.G_ClientBasicInfoId, "", this.rid, this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX')), this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"))).subscribe((res: any) => {
      if (res != null) {
        console.log("Response", res);
        //Added by tishya for IIFL-1000
        if (res.responseMessage == "Invalid IFSC Code") {
          this.Loader.hide();
          this.CallSuccessFailAlertModal("Bank Code is not valid. OrderId not generated!");
        }
        else if (res.responseMessage == "None") {
          this.Loader.hide();
          this.CallSuccessFailAlertModal("Your bank is not supported for Netbanking / UPI on Razorpay. Please use a different bank or another payment method.")
        }
        //Ended by tishya for IIFL-1000
        else {
          if (res.Id) {
            this.orderId = res.Id; //Order id from responses
            console.log(this.orderId);
            debugger
            let RazorpaySaveDetailsRequest = {
              PaymentReferenceID: PaymentReferenceID
            };
            var str = this.G_ClientBasicInfoId + "|" + PaymentReferenceID; //Added by tishya for Razorpay Callback URL Appending Payment Reference ID
            var clientbasicinfo = this.EncrdecrService.setEncr(str); //Added by tishya for Razorpay Callback URL
            const options = {
              key: environment.RazorPayKey,
              amount: (this.PayableAmount * 100),  // Amount in paise (50000 paise = 500 INR)
              currency: 'INR',
              name: 'IIFL',
              description: 'Test Transaction',
              image: 'https://example.com/your_logo.png',
              order_id: this.orderId,//'order_Pbp7LYgL0MdN20',  // This order_id is typically generated via your backend API
              // handler: (response: any) => {
              //   // Handle successful payment
              //   console.log("Handler", response);
              //   this.RazorpaySavingDetails(response, PaymentReferenceID);
              //   // alert('Payment Successful!'); alert(`Payment ID: ${response.razorpay_payment_id}`);alert(`Order ID: ${response.razorpay_order_id}`);alert(`Signature: ${response.razorpay_signature}`);
              // },
              // callback_url: `${this.RazorPayCallBackURL}${clientbasicinfo}`, //Added by Tishya for Netbanking redirection issue
              callback_url: `${this.RazorPayCallBackURL}`, //Added by Tishya for getting the Razorpay wehbhook status for this client
              redirect: true, //Added by Tishya
              prefill: {
                name: this.ClientName,
                email: this.ClientEmailId,
                contact: this.ClientMobileNo
              },
              notes: {
                address: 'Razorpay Corporate Office'
              },
              theme: {
                color: '#3399cc'
              }
            };

            const rzp1 = new Razorpay(options);

            // Handle failed payments
            rzp1.on('payment.failed', (response: any) => {
              // alert('Payment failed');alert(`Error Code: ${response.error.code}`);
              this.Loader.hide();
              // this.CallAlertModal(response.error.description);
              // alert(`Error Source: ${response.error.source}`); alert(`Error Step: ${response.error.step}`);alert(`Error Reason: ${response.error.reason}`);
              // alert(`Order ID: ${response.error.metadata.order_id}`); alert(`Payment ID: ${response.error.metadata.payment_id}`);
            });

            // Open the Razorpay payment modal
            rzp1.open();
          }
          else {
            this.Loader.hide();//Added by Saddam on 23122025
            this.CallSuccessFailAlertModal("Something went wrong OrderId not generated!");
          }
        }


      }
    },
      (err: any) => {
        this.Loader.hide();
      });

  }
  //second method for payment checkout
  PaymentCheck(Data: any) {

    let paymentData = {
      order_id: Data.razorpay_order_id,
      payment_id: Data.razorpay_payment_id,
      signature: Data.razorpay_signature,
    };


    this.distributorOnboardingService.PaymentVarify({}, this.G_ClientBasicInfoId, paymentData.payment_id, paymentData.order_id).subscribe(
      (res: any) => {
        debugger
        if (res != null) {
          if (res.lstPaymentRes[0].status == "captured") {
            this.Loader.hide();
            this.CallAlertModal("Payment Successfully Done!!!!");
          }
          else {
            this.Loader.hide();
            this.CallAlertModal("Something went wrong");
          }
        }
      },
      (err: any) => {
        this.Loader.hide();
        this.CallAlertModal("Something went wrong");
      }
    )
  }
  RazorpaySavingDetails(Data, PaymentReferenceID) {
    let RazorpaySaveDetailsRequest = {
      order_id: Data.razorpay_order_id,
      payment_id: Data.razorpay_payment_id,
      signature: Data.razorpay_signature,
      PaymentReferenceID: PaymentReferenceID
    };
    this.distributorOnboardingService.SavingRazorPayResponse(RazorpaySaveDetailsRequest, this.EncrdecrService.setEncr(Data), this.G_ClientBasicInfoId).subscribe((res: any) => {
      debugger
      this.Loader.hide();
      console.log("Response", res)
      if (res.Message == "Payment Verified") {
        if (!isNullOrUndefined(sessionStorage.getItem("rfrg343")) && sessionStorage.getItem("rfrg343") && sessionStorage.getItem("rfrg343") == "Cart") {
          this.CallCartLinkSuccessModel("Payment verified successfully.");
        }
        else {
          this.CallSuccessFailAlertModal("Payment verified successfully.");
        }
      }
    })
  }

  // CallAlertModal(msg: any) {
  //   $("#AlertModal").modal({ backdrop: "static", keyboard: false });
  //   $("#AlertModalContent").text(msg);
  // }

  CallAlertModal(msg: any) {
    $("#AlertModalprofilemodels").modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertModalContentmodels').text(msg);
  }
  CallSuccessFailAlertModal(msg: any) {
    $("#MoreTransactionmodelAutoPay").modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#MoreTransactionContentmodelAutoPay').text(msg);
  }

  //Updated by Dalsukh
  SetSelectedPaymentMode(PaymentMode: string) {
    debugger

    if (this.showAndClearMessage(PaymentMode)) {
      return;
    }

    if (PaymentMode === 'CHEQUE' || PaymentMode === 'CHEQUEMODE') {
      this.ResetMessage(PaymentMode);
    }

    if (PaymentMode == 'NEFT/RTGS' && this.collapseElement.nativeElement.classList.contains("show")) {
      this.renderer.removeClass(this.collapseElement.nativeElement, 'show'); // Remove the 'collapse' class
      this.renderer.addClass(this.collapseElement.nativeElement, 'collapse');
    }
    // else if (PaymentMode == 'NEFT/RTGS' && this.collapseElement.nativeElement.classList.contains("collapse")) {
    //   this.renderer.removeClass(this.collapseElement.nativeElement, 'collapse'); // Remove the 'collapse' class
    //   this.renderer.addClass(this.collapseElement.nativeElement, 'show');
    // }
    else if (PaymentMode == 'AutoPay' && this.collapseElement1.nativeElement.classList.contains("show")) {
      this.renderer.removeClass(this.collapseElement1.nativeElement, 'show'); // Remove the 'collapse' class
      this.renderer.addClass(this.collapseElement1.nativeElement, 'collapse');
    }
    // else if (PaymentMode == 'AutoPay' && this.collapseElement1.nativeElement.classList.contains("collapse")) {
    //   this.renderer.removeClass(this.collapseElement1.nativeElement, 'collapse'); // Remove the 'collapse' class
    //   this.renderer.addClass(this.collapseElement1.nativeElement, 'show');
    // }
    else if (PaymentMode == 'PaymentGateway' && this.collapseElement3.nativeElement.classList.contains("show")) {
      this.renderer.removeClass(this.collapseElement3.nativeElement, 'show'); // Remove the 'collapse' class
      this.renderer.addClass(this.collapseElement3.nativeElement, 'collapse');
    }
    else if (PaymentMode == 'UPI' && this.collapseUPIElement3.nativeElement.classList.contains("show")) {
      this.renderer.removeClass(this.collapseUPIElement3.nativeElement, 'show'); // Remove the 'collapse' class
      this.renderer.addClass(this.collapseUPIElement3.nativeElement, 'collapse');
    }
    // else if (PaymentMode == 'PaymentGateway' && this.collapseElement3.nativeElement.classList.contains("collapse")) {
    //   this.renderer.removeClass(this.collapseElement3.nativeElement, 'collapse'); // Remove the 'collapse' class
    //   this.renderer.addClass(this.collapseElement3.nativeElement, 'show');
    // }
    else if (PaymentMode == 'CHEQUEMODE' && this.collapseElement7.nativeElement.classList.contains("show")) {
      if (this.collapseElement) {
        // this.Allow = PaymentMode != this.previousTran
        this.renderer.removeClass(this.collapseElement7.nativeElement, 'show'); // Remove the 'collapse' class
        this.renderer.addClass(this.collapseElement7.nativeElement, 'collapse');  // Add the 'show' class to expand it
      }
    }
    else {
      this.TempselectedPaymentMethod = PaymentMode;
      if (PaymentMode == 'NEFT/RTGS') {
        if (this.NEFTPayClick == false) {
          this.ConfirmTransactionPopup(`Do you want to proceed with ${PaymentMode} ?`);
        }
      }
      else if (PaymentMode == 'CHEQUE') {
        this.ConfirmChallanGenerationPopup(`Do you want to proceed with cheque ?`);
      }
      //Added by Tishya 27/01/2025
      else {
        this.paymentModeSelected()
      }
      //Added by Tishya 27/01/2025
    }

  }

  showAndClearMessage(paymentMode: any) {
    if (paymentMode === 'CHEQUE') {
      const chequeControl = this.ChequeForm.get('CHEQUENO');
      const chequeDateControl = this.ChequeForm.get('chqDate');
      if (chequeControl) {
        chequeControl.markAsTouched(); // Mark as touched
        chequeControl.markAsDirty();   // Mark as dirty
        chequeControl.updateValueAndValidity(); // Trigger validation
      }
      if (chequeDateControl) {
        chequeDateControl.markAsTouched(); // Mark as touched
        chequeDateControl.markAsDirty();   // Mark as dirty
        chequeDateControl.updateValueAndValidity(); // Trigger validation
      }
      if (isNullOrUndefined(this.selectedChequeAccount)) {
        this.showChequeBankError = true;
        return true;
      }
      if (this.ChequeForm.invalid) {
        return true;
      }

      let chequeNo = this.ChequeForm.controls["CHEQUENO"].value;

      if (chequeNo == "000000") {
        this.VerifyChequeNoModel("Invalid cheque number format.");
        this.ChequeForm.controls['CHEQUENO'].setValue('');
        return true;
      }

      if (this.validateManualDate(this.ChequeForm.controls["chqDate"].value)) {
        return true;
      }

    }
    return false;
  }

  ResetMessage(paymentMode: any) {
    if (paymentMode === 'CHEQUE') {
      return;
    }
    // this.UpiForm.reset();
    this.ChequeForm.reset();
    // this.showUpiBankError = false;
    // this.showNetBankError = false;
    this.showChequeBankError = false;
    // $('.CustomSelectNetBankingBank').val("").trigger('change');
    $('.CustomSelectChequeBank').val("").trigger('change');
    // $('.CustomSelectUPIBank').val("").trigger('change');
  }

  VerifyChequeNumber() {

    // if(this.selectedPaymentMethod == "CHEQUE"){

    this.Loader.show();

    this.isTransactionForChallanInitiated = true;

    let allBankDetail = this.selectedChequeAccount.split("|");

    let UCCCode = "";
    if (!isNullOrUndefined(sessionStorage.getItem("sdochsidjcsdv")) && sessionStorage.getItem("sdochsidjcsdv") != "") {
      UCCCode = this.EncrdecrService.getDecr(sessionStorage.getItem("sdochsidjcsdv"));
    }

    let DataBody =
    {
      AccNo: allBankDetail[0],
      ChequeNo: this.ChequeForm.controls["CHEQUENO"].value ?? "",
      UCC: UCCCode
    }

    this.transactionBSe.VerifyChequeNo(DataBody).subscribe((data: any) => {

      this.Loader.hide();

      // let data = {
      //         "code": 0,
      //         "Message": "",
      //         "ID": 200,
      //         "Refference_No": "",
      //         "FilePath": "",
      //         "ReturnMessage": "",
      //         "Code": "",
      //         "Data": "",
      //         "reference_id": null,
      //         "Param1": null,
      //         "Param2": null,
      //         "Param3": null,
      //         "Param4": null,
      //         "Param5": null,
      //         "Param6": null,
      //         "Param7": null,
      //         "Param8": null,
      //         "data": null,
      //         "ClientBasicInfoId": 0,
      //         "OrderId": 0,
      //         "SecondHolderOrderId": 0,
      //         "SecondHolderStatusCode": 0,
      //         "GenPayLink": null,
      //         "FH_TNCLinkID": 0,
      //         "SH_TNCLinkID": 0,
      //         "status": null,
      //         "HolderType": "",
      //         "PaymentMode": "",
      //         "HoldingType": "",
      //         "PaymentLink": "",
      //         "Tenure": "",
      //         "Amount": "",
      //         "NomineeFlag": "",
      //         "IsMobile": 0
      //       }

      debugger
      if (data != null) {

        if (data.ID == 200) {

          const msg = `
                      The cheque number you entered has already been used. Please provide a different cheque to complete your transaction.
                    `;
          this.VerifyChequeNoModel(msg);

          return;
        }
        else {

          // this.ConfirmTransactPopup(`Do you want to proceed with CHEQUE payment mode ?`);

          this.ProceedNEFTRTGS();

          if (this.collapseElement) {
            this.renderer.removeClass(this.collapseElement7.nativeElement, 'collapse'); // Remove the 'collapse' class
            this.renderer.addClass(this.collapseElement7.nativeElement, 'show');  // Add the 'show' class to expand it
          }
          this.ChequeForm.controls["CHEQUENO"].setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern(NumberOnly)])
          this.ChequeForm.controls["CHEQUENO"].updateValueAndValidity();
          this.ChequeForm.controls["chqDate"].setValidators(Validators.required)
          this.ChequeForm.controls["chqDate"].updateValueAndValidity()

        }
      }

    })

  }

  VerifyChequeNoModel(msg) {
    $("#VerifyChequeNoModel").modal({
      backdrop: "static",
      keyboard: false,
    });

    const formattedMsg = msg
      .replace(/#/, '') // remove hashes if you want
      .replace(/\.\s*/g, '.<br>') // add <br> after every period followed by space—to break sentences into lines
      .trim();

    $("#VerifyChequeNoModelContent").html(formattedMsg);
  }

  ClosePopUp() {
    debugger
    $('#VerifyChequeNoModel').modal('hide');
  }

  ConfirmTransactPopup(msg: any) {
    $("#ConfirmTransactmodels").modal({ backdrop: 'static', keyboard: false });
    $("#ConfirmTransactContentmodels").text(msg);
  }

  DeleteTransactionAfterSuccess(CartId) {
    let Db = { "CartId": CartId, "Flag": "Delete" }
    this.transactionBSe.CartDeleteItems(Db).subscribe(response => {
      let data = JSON.parse(this.EncrdecrService.getDecr(response))
      if (data.ID > 0) {
        if (data.Message === "Record delete successfully.") {
          // this.ShowCartList();
        }
      }
    });
  }

  CloseMainModal() {
    this.summaryservice.setSummaryData([]);
    window.location.reload();
    this.bsModalRef.hide();
  }

  copyFromText(event: Event, elementID: any): void {
    // Get the button element that was clicked
    const button = event.target as HTMLButtonElement;

    // Find the previous sibling element with the text
    const copyableTextElement = document.getElementById(elementID) as HTMLElement;

    // Get the text content from the sibling
    var textToCopy = copyableTextElement?.textContent || '';

    if (textToCopy) {
      textToCopy = textToCopy.trim();
      if (navigator.clipboard) {
        // Use Clipboard API
        navigator.clipboard.writeText(textToCopy).then(
          () => {
            // alert(`Copied: ${textToCopy}`);
          },
          (err) => {
            console.error('Could not copy text: ', err);
          }
        );
      } else {
        // Fallback for older browsers
        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          // alert(`Copied: ${textToCopy}`);
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
        document.body.removeChild(textarea);
      }
    } else {
      // alert('No text found to copy.');
    }
  }
  isNullOrEmpty(value: string | null | undefined): string {
    return (value === null || value === undefined) ? ' ' : value;
  }
  CartBSEProcess(PaymentReferenceID = "") {
    debugger
    let newKey = 'PaymentType';
    let newValue = this.selectedPaymentMethod;
    this.cartServiceData.forEach(item => {
      item[newKey] = newValue;
      item["PaymentReferenceID"] = PaymentReferenceID;

      item["Bank"] = this.selectedBankAccount ?? "";
      item["Cheque"] = this.ChequeForm.controls["CHEQUENO"].value ?? "";
      item["ChequeDate"] = this.ChequeForm.controls["chqDate"].value ?? "";

      let AppSource = "Web";

      if (sessionStorage.getItem("sxafkmoscmoascok") != undefined &&
        sessionStorage.getItem("sxafkmoscmoascok") != null &&
        sessionStorage.getItem("sxafkmoscmoascok") != "") {
        AppSource = sessionStorage.getItem("sxafkmoscmoascok");
      }

      item["AppSource"] = AppSource;

      if (this.selectedPaymentMethod == "AutoPay") {
        let newKey2 = 'OTMMandateId';
        let newValue2 = this.SelectedMandateCode;
        item[newKey2] = newValue2;

        // let newKey3 = 'MandateBank';
        // let newValue3 = this.MandateBank;
        // item[newKey3] = newValue3;

      }
      else {
        let newKey2 = 'OTMMandateId';
        let newValue2 = null;
        item[newKey2] = newValue2;

        // let newKey3 = 'MandateBank';
        // let newValue3 = null;
        // item[newKey3] = newValue3;
      }

    });
    console.log("Updated cart", this.cartServiceData);
    this.ClientData = JSON.parse(this.EncrdecrService.getDecr(sessionStorage.getItem("asjkldnakje34234nwbes")));// For cart service only
    console.log("Client Data :::", this.ClientData);// For cart service only

    this.performSynchronousCartTransaction();

    if (sessionStorage.getItem('asgfasghdfgjghd') != '' && sessionStorage.getItem('asgfasghdfgjghd') != null && sessionStorage.getItem('asgfasghdfgjghd') != undefined) {
      const isRedirect = this.EncrdecrService.getDecr(sessionStorage.getItem('asgfasghdfgjghd'));

      if (isRedirect) {
        this.captureCartCheckout(this.PayableAmount.toString(), this.cartServiceData?.map(item => item.FundName)?.filter(Boolean)?.join(', ') || '', this.cartServiceData?.[0]?.PaymentType);
        sessionStorage.removeItem("asgfasghdfgjghd");
      }
    }

    // this.cartServiceData.forEach(element => {
    //   //Added by Tishya for RazorPay Prefill data
    //   this.ClientName = this.ClientData.clientname.split('-')[0].trim(); // For cart service only
    //   this.ClientEmailId = element.EmailId,
    //     this.ClientMobileNo = element.MobileNumber
    //   //Added by Tishya for RazorPay Prefill data
    //   console.log("Client Details:", this.ClientName + " " + this.ClientEmailId + " " + this.ClientMobileNo);
    //   console.log("Data Inside PaymentMode Popup => " + JSON.stringify(element));
    //   debugger
    //   this.UCCCode = element.UccCode;
    //   // if (this.cartIndex < this.cartServiceData.length) {
    //   if (element.page == "cartLumpsum") {
    //     this.TransType_RazorPay = "Lumpsum";
    //     //Changed by tishya 18/12/2024
    //     this.transactionBSe.InvestToLumpsumCart(element).subscribe(
    //       (response: any) => {
    //         debugger
    //         let result = JSON.parse(this.EncrdecrService.getDecr(response))
    //         if (result != null) {
    //           if (result.Message != null && result.Message != '' && result.Message.indexOf('Not Autherised') > -1) {
    //             this.Loader.hide();
    //             this.router.navigateByUrl('/login-incred');
    //             return;
    //           }
    //           else {
    //             ////////
    //             //console.log('Response');
    //             //console.log(result);
    //             if (result.SuccessFlag == 0) {
    //               this.OrderSuccessFlag.push(result.SuccessFlag);
    //               if (this.selectedPaymentMethod != "NEFT/RTGS") {

    //                 this.ResponseMsg += this.RespmsgId + ". " + result.Message;
    //               }
    //               this.PayableAmount += parseInt(this.EncrdecrService.getDecr(element.Amount));
    //               this.FinalOrderNo += result.FinalOrderNo + ",";
    //               this.OrderNo += result.OrderNo + ",";
    //               this.RespmsgId++;
    //               let MailRequest = { ...element, ...result };
    //               this.SendMail("LumpsumBSE", MailRequest);
    //               this.DeleteTransactionAfterSuccess(element.CartId);
    //               //this.ClearAll();
    //             }
    //             else if (result.SuccessFlag == 1) {
    //               this.OrderSuccessFlag.push(result.SuccessFlag);
    //               this.ResponseMsg += this.RespmsgId + ". " + result.Message + " " + element.SIPMode + "-" + element.FundName + "-" + this.EncrdecrService.getDecr(element.Amount) + "<br><br>";
    //               this.RespmsgId++;
    //               let RejectedMailRequest = { ...result, ...element };
    //               this.SendRejectedMail("LumpsumBSE", RejectedMailRequest);
    //               //this.ClearAll();
    //             }
    //             else {
    //               this.ResponseMsg += "Exception Occured" + "<br><br>";
    //               //this.ClearAll();
    //             }
    //             console.log("OrderSuccessFlag Array: " + this.OrderSuccessFlag);
    //             // if (element == this.SchemeList.length) {

    //             //   if (result.SuccessFlag == 0) {
    //             //     if (this.G_UserType === 3) {
    //             //       this.bsModelRef = this.bsModelService.show(PaymentModePopupComponent, {
    //             //         class: "modal-dialog-centered modal-lg modal_otp",
    //             //         ignoreBackdropClick: true
    //             //       });
    //             //       // const paymentURL = result.PaymentUrl;
    //             //       // window.open(paymentURL, "_blank");
    //             //       // this.CallAlertModal("Payment page would have opened in new tab, please make the payment to complete transaction. You may also complete the transaction by clicking on the link received on email.");
    //             //       //this.CallAlertModal("Please complete the transaction by clicking on the link received on registed email Id.");

    //             //     } else {
    //             //       this.CallUpdateCartModal(); // Need to add modified alert modal
    //             //     }
    //             //   }
    //             //   else {
    //             //     this.CallUpdateCartModal(); //Need to add modified alert modal
    //             //   }
    //             //   this.Loader.hide();
    //             //   //               this.Loader.hide();
    //             //   // this.CallAlertModal(this.ResponseMsg);
    //             // }
    //           }
    //         }
    //       });
    //   }
    //   else if (element.page == "cartSIP") {
    //     this.TransType_RazorPay = "SIP";
    //     debugger
    //     if (!isNullOrUndefined(element.MandateCode) && element.MandateCode != "") {
    //       element.MandateCode = element.MandateCode.split("/")[0];
    //     }
    //     this.transactionBSe.InvestToSIPCart(element).subscribe(
    //       (response: any) => {
    //         let result = JSON.parse(this.EncrdecrService.getDecr(response))
    //         ////////
    //         debugger
    //         if (result != null) {
    //           if (result.Message != null && result.Message != '' && result.Message.indexOf('Not Autherised') > -1) {
    //             this.Loader.hide();
    //             this.router.navigateByUrl('/login-incred');
    //             return;
    //           }
    //           else {
    //             // result.SuccessFlag = 0;
    //             // result.OrderNo = 0;
    //             // result.FinalOrderNo = 0;
    //             if (result.SuccessFlag == 0) {
    //               this.OrderSuccessFlag.push(result.SuccessFlag);
    //               // element.FirstOrderFlag = "N";
    //               if (this.selectedPaymentMethod != "NEFT/RTGS") {

    //                 this.ResponseMsg += this.RespmsgId + ". " + result.Message + "<br><br>";
    //               }
    //               this.PayableAmount += element.FirstOrderFlag == "Y" ? parseInt(this.EncrdecrService.getDecr(element.Amount)) : 0;

    //               this.OrderNo += result.FinalOrderNo + ",";
    //               this.FinalOrderNo += result.FinalOrderNo + ",";
    //               this.RespmsgId++;
    //               let MailRequest = { ...result, ...element };
    //               this.SendMail("SIPBse", MailRequest);
    //               this.DeleteTransactionAfterSuccess(element.CartId);
    //               //this.ClearAll();
    //             } else if (result.SuccessFlag == 1) {
    //               this.OrderSuccessFlag.push(result.SuccessFlag);
    //               this.ResponseMsg += this.RespmsgId + ". " + this.isNullOrEmpty(result.Message) + " " + this.isNullOrEmpty(element.SIPMode) + "-" + this.isNullOrEmpty(element.FundName) + "-" + this.isNullOrEmpty(this.EncrdecrService.getDecr(element.Amount)) + "<br><br>";
    //               this.RespmsgId++;
    //               let RejectedMailRequest = { ...result, ...element };
    //               this.SendRejectedMail("SIPBSE", RejectedMailRequest);
    //               //this.ClearAll();
    //             } else {
    //               this.ResponseMsg += "Exception Occured" + "<br><br>";
    //               //this.ClearAll();
    //             }

    //             this.LumsumOrderStatus.push(result);

    //             // this.cartIndex++;
    //             // setTimeout(() => this.FinalCall(), 3000);
    //             // console.log(this.cartIndex);

    //             // if (this.cartIndex == this.SchemeList.length) {
    //             //   ////////
    //             //   if (result.SuccessFlag == 0) {
    //             //     if (this.G_UserType === 3) {
    //             //       // const paymentURL = result.PaymentUrl;
    //             //       // window.open(paymentURL, "_blank");
    //             //       // this.CallAlertModal("Payment page would have opened in new tab, please make the payment to complete transaction. You may also complete the transaction by clicking on the link received on email.");
    //             //       //this.CallAlertModal("Please complete the transaction by clicking on the link received on registed email Id.");
    //             //     } else {
    //             //       this.CallUpdateCartModal();
    //             //     }
    //             //   }
    //             //   else {
    //             //     this.CallUpdateCartModal();
    //             //   }
    //             //   this.Loader.hide();

    //             // }
    //           }
    //         }
    //       });
    //   }


    //   // }
    // });
    this.OrderSuccessFlag = [];
    if (this.RespmsgId) {
      let interval = setInterval(() => {
        this.counter++;
        if (this.RespmsgId > this.cartServiceData.length) {
          debugger
          this.Loader.hide();
          let SuccessFlag = this.OrderSuccessFlag.filter(success => success == 0);
          let FailureFlag = this.OrderSuccessFlag.filter(Fail => Fail == 1);
          console.log("SuccessFlag", SuccessFlag);
          console.log("FailureFlag", FailureFlag);

          if (SuccessFlag.length > 0 && FailureFlag.length > 0) {
            console.log("Case 1");

            this.Amount = this.PayableAmount;
            if (this.ResponseMsg.includes("<br/>")) {
              $("#NEFTFailureReason").html("<p><strong>Reason: </strong>" + this.ResponseMsg + "</p>");
            } else {
              this.FailureReason = this.ResponseMsg;
            }


            if (this.selectedPaymentMethod == "NEFT/RTGS") {
              this.IsShowSuccessAndFail = true;
              if (this.collapseElement) {
                this.renderer.removeClass(this.collapseElement.nativeElement, 'collapse'); // Remove the 'collapse' class
                this.renderer.addClass(this.collapseElement.nativeElement, 'show');  // Add the 'show' class to expand it
                // this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabledAfterPayment');
                clearInterval(interval);
              }
            }
            if (this.selectedPaymentMethod == "AutoPay") {
              // this.ShowFailureAutoPayDetails = true;
              // this.ShowSuccessAutoPayDetails = true;
              // this.FailureReason = this.ResponseMsg;
              // this.CallAlertModal(this.ResponseMsg);
              if (!isNullOrUndefined(sessionStorage.getItem("rfrg343")) && sessionStorage.getItem("rfrg343") && sessionStorage.getItem("rfrg343") == "Cart") {
                this.CallCartLinkSuccessModel(this.ResponseMsg);
              }
              else {
                this.CallSuccessFailAlertModal(this.ResponseMsg);
              }
              clearInterval(interval);

            }
            if (this.selectedPaymentMethod == "PaymentGateway"|| this.selectedPaymentMethod == "UPI") {
              //this.CallAlertModal(this.ResponseMsg);
              // this.RazorPayCallToCreateOrder(PaymentReferenceID);  //Siddhesh_23072026
               var FinalOrder= this.SuccessOrderNumber.length == 1 ? this.SuccessOrderNumber[0] : this.SuccessOrderNumber.join("|");
              this.GetNetBankingPageIncred(FinalOrder, this.PayableAmount, this.selectedPaymentMethod, this.UPIForm.controls["UPIID"].value, this.UCCCode);

              clearInterval(interval);
            }

            if (this.selectedPaymentMethod == 'CHEQUE') {

              this.SendReqForChallan(this.OrderNo, this.PayableAmount, this.UCCCode);
              clearInterval(interval);

            }
          }
          else if (SuccessFlag.length == this.cartServiceData.length) {
            console.log("Case 2");
            this.Amount = this.PayableAmount;
            // this.FailureReason = this.ResponseMsg;
            if (this.selectedPaymentMethod == "NEFT/RTGS") {
              this.ShowSuccessNEFTDetails = true;
              if (this.collapseElement) {
                this.renderer.removeClass(this.collapseElement.nativeElement, 'collapse'); // Remove the 'collapse' class
                this.renderer.addClass(this.collapseElement.nativeElement, 'show');  // Add the 'show' class to expand it
                // this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabledAfterPayment');
                clearInterval(interval);
              }
            }
            if (this.selectedPaymentMethod == "AutoPay") {
              // this.ShowFailureAutoPayDetails = false;
              // this.ShowSuccessAutoPayDetails = true;
              // this.FailureReason = this.ResponseMsg;
              // this.CallAlertModal(this.ResponseMsg);
              if (!isNullOrUndefined(sessionStorage.getItem("rfrg343")) && sessionStorage.getItem("rfrg343") && sessionStorage.getItem("rfrg343") == "Cart") {
                this.CallCartLinkSuccessModel(this.ResponseMsg);
              }
              else {
                this.CallSuccessFailAlertModal("Orders initiated successfully");
              }
              console.log("Orderid:", this.OrderNo);
              clearInterval(interval);

            }
            if (this.selectedPaymentMethod == "PaymentGateway"|| this.selectedPaymentMethod == "UPI") {
              // this.RazorPayCallToCreateOrder(PaymentReferenceID);  //Siddhesh_23072026
              var FinalOrder= this.SuccessOrderNumber.length == 1 ? this.SuccessOrderNumber[0] : this.SuccessOrderNumber.join("|");
              this.GetNetBankingPageIncred(FinalOrder, this.PayableAmount, this.selectedPaymentMethod, this.UPIForm.controls["UPIID"].value, this.UCCCode);


              clearInterval(interval);
            }

            if (this.selectedPaymentMethod == 'CHEQUE') {

              this.SendReqForChallan(this.OrderNo, this.PayableAmount, this.UCCCode);
              clearInterval(interval);

            }

          }
          else if (FailureFlag.length == this.cartServiceData.length) {
            console.log("Case 3");
            if (this.selectedPaymentMethod == "NEFT/RTGS") {
              this.ShowSuccessNEFTDetails = false;
              if (this.ResponseMsg.includes("<br/>")) {
                $("#NEFTFailureReason").html("<p><strong>Reason: </strong>" + this.ResponseMsg + "</p>");
              } else {
                this.FailureReason = this.ResponseMsg;
              }

              if (this.collapseElement) {
                this.renderer.removeClass(this.collapseElement.nativeElement, 'collapse'); // Remove the 'collapse' class
                this.renderer.addClass(this.collapseElement.nativeElement, 'show');  // Add the 'show' class to expand it
                // this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabledAfterPayment');
                clearInterval(interval);
              }
            }
            if (this.selectedPaymentMethod == "AutoPay") {
              // this.ShowFailureAutoPayDetails = true;
              // this.ShowSuccessAutoPayDetails = false;
              // this.FailureReason = this.ResponseMsg;
              // console.log("Orderid:", this.OrderNo);
              if (!isNullOrUndefined(sessionStorage.getItem("rfrg343")) && sessionStorage.getItem("rfrg343") && sessionStorage.getItem("rfrg343") == "Cart") {
                this.CallCartLinkFailureModel(this.ResponseMsg);
              }
              else {
                this.CallSuccessFailAlertModal(this.ResponseMsg);
              }
              clearInterval(interval);
            }
            if (this.selectedPaymentMethod == "PaymentGateway"|| this.selectedPaymentMethod == "UPI") {
              if (!isNullOrUndefined(sessionStorage.getItem("rfrg343")) && sessionStorage.getItem("rfrg343") && sessionStorage.getItem("rfrg343") == "Cart") {
                this.CallCartLinkFailureModel(this.ResponseMsg);
              }
              else {
                this.CallSuccessFailAlertModal(this.ResponseMsg);
              }
              clearInterval(interval);
            }

            if (this.selectedPaymentMethod == "CHEQUE") {
              this.CallSuccessFailAlertModal(this.ResponseMsg);
              clearInterval(interval);
            }

          }
          else if (FailureFlag.length > 0 && SuccessFlag.length == 0) {
            console.log("Case 4");
            if (this.selectedPaymentMethod == "NEFT/RTGS") {
              this.ShowSuccessNEFTDetails = false;
              if (this.ResponseMsg.includes("<br/>")) {
                $("#NEFTFailureReason").html("<p><strong>Reason: </strong>" + this.ResponseMsg + "</p>");
              } else {
                this.FailureReason = this.ResponseMsg;
              }

              if (this.collapseElement) {
                this.renderer.removeClass(this.collapseElement.nativeElement, 'collapse'); // Remove the 'collapse' class
                this.renderer.addClass(this.collapseElement.nativeElement, 'show');  // Add the 'show' class to expand it
                // this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabledAfterPayment');
                clearInterval(interval);
              }
            }
            if (this.selectedPaymentMethod == "AutoPay") {
              // this.ShowFailureAutoPayDetails = true;
              // this.ShowSuccessAutoPayDetails = false;
              // this.FailureReason = this.ResponseMsg;
              // console.log("Orderid:", this.OrderNo);
              if (!isNullOrUndefined(sessionStorage.getItem("rfrg343")) && sessionStorage.getItem("rfrg343") && sessionStorage.getItem("rfrg343") == "Cart") {
                this.CallCartLinkFailureModel(this.ResponseMsg);
              }
              else {
                this.CallSuccessFailAlertModal(this.ResponseMsg);
              }
              clearInterval(interval);
            }
            if (this.selectedPaymentMethod == "PaymentGateway"|| this.selectedPaymentMethod == "UPI") {
              if (!isNullOrUndefined(sessionStorage.getItem("rfrg343")) && sessionStorage.getItem("rfrg343") && sessionStorage.getItem("rfrg343") == "Cart") {
                this.CallCartLinkFailureModel(this.ResponseMsg);
              }
              else {
                this.CallSuccessFailAlertModal(this.ResponseMsg);
              }
              clearInterval(interval);
            }

            if (this.selectedPaymentMethod == "CHEQUE") {
              this.CallSuccessFailAlertModal(this.ResponseMsg);
              clearInterval(interval);
            }


          }
          else if (FailureFlag.length == 0 && SuccessFlag.length > 0) {
            console.log("Case 5");
            if (this.selectedPaymentMethod == "NEFT/RTGS") {
              this.ShowSuccessNEFTDetails = false;
              if (this.ResponseMsg.includes("<br/>")) {
                $("#NEFTFailureReason").html("<p><strong>Reason: </strong>" + this.ResponseMsg + "</p>");
              } else {
                this.FailureReason = this.ResponseMsg;
              }

              if (this.collapseElement) {
                this.renderer.removeClass(this.collapseElement.nativeElement, 'collapse'); // Remove the 'collapse' class
                this.renderer.addClass(this.collapseElement.nativeElement, 'show');  // Add the 'show' class to expand it
                // this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabledAfterPayment');
                clearInterval(interval);
              }
            }
            if (this.selectedPaymentMethod == "AutoPay") {
              // this.ShowFailureAutoPayDetails = true;
              // this.ShowSuccessAutoPayDetails = false;
              // this.FailureReason = this.ResponseMsg;
              // console.log("Orderid:", this.OrderNo);
              if (!isNullOrUndefined(sessionStorage.getItem("rfrg343")) && sessionStorage.getItem("rfrg343") && sessionStorage.getItem("rfrg343") == "Cart") {
                this.CallCartLinkSuccessModel(this.ResponseMsg);
              }
              else {
                this.CallSuccessFailAlertModal("Orders initiated successfully");
              }
              clearInterval(interval);
            }
            if (this.selectedPaymentMethod == "PaymentGateway"|| this.selectedPaymentMethod == "UPI") {
              //this.RazorPayCallToCreateOrder(PaymentReferenceID);  //Siddhesh_23072026
              
             var FinalOrder= this.SuccessOrderNumber.length == 1 ? this.SuccessOrderNumber[0] : this.SuccessOrderNumber.join("|");
              this.GetNetBankingPageIncred(FinalOrder, this.PayableAmount, this.selectedPaymentMethod, this.UPIForm.controls["UPIID"].value, this.UCCCode);

              clearInterval(interval);
            }

            if (this.selectedPaymentMethod == 'CHEQUE') {

              this.SendReqForChallan(this.OrderNo, this.PayableAmount, this.UCCCode);
              clearInterval(interval);

            }

          }
          if (this.counter >= this.cartServiceData.length + 20) {
            console.log('Interval stopped');
            clearInterval(interval);  // Stops the interval
          }
        }

      }, 1000)
    }
  }

  async performSynchronousCartTransaction() {
    debugger;
    for (let element of this.cartServiceData) {
      try {
        // Setting up client data
        this.ClientName = this.ClientData.clientname.split('-')[0].trim(); // For cart service only
        this.ClientEmailId = element.EmailId;
        this.ClientMobileNo = element.MobileNumber;
        console.log("Client Details:", this.ClientName + " " + this.ClientEmailId + " " + this.ClientMobileNo);
        console.log("Data Inside PaymentMode Popup => " + JSON.stringify(element));

        // Handle the UCC code
        this.UCCCode = element.UccCode;

        // If page is "cartLumpsum", process Lumpsum transaction
        if (element.page == "cartLumpsum") {
          this.TransType_RazorPay = "Lumpsum";

          // Wait for the API response using await
          const response = await this.transactionBSe.InvestToLumpsumCart(element,
            this.rid,
            this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX')),
            this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"))).toPromise();
          const result = JSON.parse(this.EncrdecrService.getDecr(response));

          if (result) {
            if (result.Message && result.Message.includes('Not Autherised')) {
              this.Loader.hide();
              this.router.navigateByUrl('/login-incred');
              return;
            }

            if (result.SuccessFlag == 0) {
              this.SuccessOrderNumber.push(result.FinalOrderNo);
              this.OrderSuccessFlag.push(result.SuccessFlag);
              if (this.selectedPaymentMethod !== "NEFT/RTGS") {
                this.ResponseMsg += this.RespmsgId + ". " + result.Message;
              }
              this.PayableAmount += parseInt(this.EncrdecrService.getDecr(element.Amount));
              this.FinalOrderNo += result.FinalOrderNo + ",";
              if (!isNullOrUndefined(this.OrderNo)) {
                this.OrderNo += result.OrderNo + ",";
              }
              else {
                this.OrderNo = result.OrderNo + ",";
              }
              this.RespmsgId++;
              let MailRequest = { ...element, ...result };
              this.SendMail("LumpsumBSE", MailRequest, element.CreatedBy, element.UserType);
              this.DeleteTransactionAfterSuccess(element.CartId);
            } else if (result.SuccessFlag == 1) {
              this.OrderSuccessFlag.push(result.SuccessFlag);
              this.ResponseMsg += this.RespmsgId + ". " + result.Message + " " + element.SIPMode + "-" + element.FundName + "-" + this.EncrdecrService.getDecr(element.Amount) + "<br><br>";
              this.RespmsgId++;
              let RejectedMailRequest = { ...result, ...element };
              this.SendRejectedMail("LumpsumBSE", RejectedMailRequest, element.CreatedBy, element.UserType);
            } else {
              this.ResponseMsg += "Exception Occurred" + "<br><br>";
            }
          }

        } else if (element.page == "cartSIP") {  // If page is "cartSIP", process SIP transaction
          this.TransType_RazorPay = "SIP";

          if (element.MandateCode && element.MandateCode !== "") {
            element.MandateCode = element.MandateCode.split("/")[0];
          }

          // Wait for the API response using await
          const sipResponse = await this.transactionBSe.InvestToSIPCart(element,
            this.rid,
            this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX')),
            this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"))).toPromise();
          const result = JSON.parse(this.EncrdecrService.getDecr(sipResponse));

          if (result) {
            if (result.Message && result.Message.includes('Not Autherised')) {
              this.Loader.hide();
              this.router.navigateByUrl('/login-incred');
              return;
            }

            if (result.SuccessFlag == 0) {
               this.SuccessOrderNumber.push(result.FinalOrderNo);
              this.OrderSuccessFlag.push(result.SuccessFlag);
              if (this.selectedPaymentMethod !== "NEFT/RTGS") {
                this.ResponseMsg += this.RespmsgId + ". " + result.Message + "<br><br>";
              }
              this.PayableAmount += element.FirstOrderFlag == "Y" ? parseInt(this.EncrdecrService.getDecr(element.Amount)) : 0;

              if (!isNullOrUndefined(this.OrderNo)) {
                if (element.FirstOrderFlag == "Y") {
                  this.OrderNo += result.FinalOrderNo + ",";
                }
              }
              else {
                if (element.FirstOrderFlag == "Y") {
                  this.OrderNo = result.FinalOrderNo + ",";
                }
              }

              this.FinalOrderNo += result.FinalOrderNo + ",";
              this.RespmsgId++;
              let MailRequest = { ...result, ...element };
              this.SendMail("SIPBse", MailRequest, element.CreatedBy, element.UserType);
              this.DeleteTransactionAfterSuccess(element.CartId);
            } else if (result.SuccessFlag == 1) {
              this.OrderSuccessFlag.push(result.SuccessFlag);
              this.ResponseMsg += this.RespmsgId + ". " + this.isNullOrEmpty(result.Message) + " " + this.isNullOrEmpty(element.SIPMode) + "-" + this.isNullOrEmpty(element.FundName) + "-" + this.isNullOrEmpty(this.EncrdecrService.getDecr(element.Amount)) + "<br><br>";
              this.RespmsgId++;
              let RejectedMailRequest = { ...result, ...element };
              this.SendRejectedMail("SIPBSE", RejectedMailRequest, element.CreatedBy, element.UserType);
            } else {
              this.ResponseMsg += "Exception Occurred" + "<br><br>";
            }
          }
        }

      } catch (error) {
        console.error("Error processing transaction:", error);
      }
    }
  }

  goToDashboard() {
    if (!isNullOrUndefined(sessionStorage.getItem("rfrg343")) && sessionStorage.getItem("rfrg343") && sessionStorage.getItem("rfrg343") == "Cart") {
      //this.bsModalRef.content.onClose.next(true);
      // $(".modal").modal("hide");
      //   this.bsModalRef.hide();
      // this.Logout.LogoutUser();
      $(".modal").modal("hide");
      this.bsModalRef.hide();
      this.Loader.show();
      this.router.navigate(['reports-new/orderbook-report']);
    }
    else {
      if (this.ShowBTNText == "" || this.ShowBTNText == null || this.ShowBTNText == undefined) {
        this.ShowBTNText = "Go to Order Book"
      }
      this.MoreTransactionPopup('Do you want to do more transactions ?');
    }
  }

  ConfirmTransactionPopup(msg: any) {
    $("#ConfirmTransactionmodels").modal({ backdrop: 'static', keyboard: false });
    $("#ConfirmTransactionContentmodels").text(msg);
  }

  ConfirmChallanGenerationPopup(msg: any) {
    $("#ConfirmChallanGenerationmodels").modal({ backdrop: 'static', keyboard: false });
    $("#ConfirmChallanGenerationContentmodels").text(msg);
  }

  MoreTransactionPopup(msg: any) {
    $("#MoreTransactionmodels").modal({ backdrop: 'static', keyboard: false });
    $("#MoreTransactionContentmodels").text(msg);
  }

  CallCartLinkSuccessModel(msg: any) {
    $("#CartLinkSuccess").modal({ backdrop: 'static', keyboard: false });
    //$("#CartLinkSuccessBody").text(msg);
  }

  CallCartLinkFailureModel(msg: any) {
    $("#CartLinkFailure").modal({ backdrop: 'static', keyboard: false });
    //$("#CartLinkFailureBody").text(msg);
  }

  ProceedNEFTRTGS() {
    this.Loader.show();
    this.FailureReason = "";
    this.NEFTPayClick = true
    console.log(this.selectedPaymentMethod);
    if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.page == "lumpsumbse") {
      console.log("summaryserviceData: " + JSON.stringify(this.cartServiceData));
      // if (this.cartServiceData.page == "lumpsumbse") {
      this.lumpsumBSEData = this.cartServiceData;
      this.LumpSumBseProcess();
      // }
    }
    if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.page == "sipbse") {
      console.log("summaryserviceData: " + JSON.stringify(this.cartServiceData));
      this.sipBSEData = this.cartServiceData;
      this.SipBseProcess();
    }
    else if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.length == 1) {
      if (this.cartServiceData[0].page == "cartLumpsum" || this.cartServiceData[0].page == "cartSIP") {
        this.CartBSEProcess();
      }
    }
    else if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.length > 1) {
      if (this.cartServiceData[0].page == "cartLumpsum" || this.cartServiceData[0].page == "cartSIP") {
        this.CartBSEProcess();
      }
    }
  }
  //Added by tishya
  ProceedAutoPay() {
    debugger
    this.AutoPayDisable = true;
    this.Loader.show();
    this.FailureReason = "";
    console.log("Payment mode:", this.selectedPaymentMethod);
    this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabled');
    this.renderer.addClass(this.RazorPayMainElement.nativeElement, 'disabled');
    this.renderer.addClass(this.UPIPayMainElement.nativeElement, 'disabled');
    if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && (this.cartServiceData.page == "lumpsumbse" || this.cartServiceData.page == "sipbse")) {
      // Dynamic key to be added
      let newKey = 'PaymentType';
      let newValue = this.selectedPaymentMethod;

      let newKey2 = 'OTMMandateId';
      let newValue2 = this.SelectedMandateCode;
      // Add the key-value pair dynamically
      this.cartServiceData[newKey] = newValue;
      this.cartServiceData[newKey2] = newValue2;
      console.log("Updated cart", this.cartServiceData);
    }
    let mandatedetails = this.mandatedetails;

    if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.page == "sipbse") {
      console.log("summaryserviceData: " + JSON.stringify(this.cartServiceData));
      let newKey = 'PaymentType';
      let newValue = this.selectedPaymentMethod;
      let newKey2 = 'OTMMandateId';
      let newValue2 = this.SelectedMandateCode;
      // Add the key-value pair dynamically
      this.cartServiceData[newKey] = newValue;
      this.cartServiceData[newKey2] = newValue2;
      // if (this.cartServiceData.page == "lumpsumbse") {
      this.sipBSEData = this.cartServiceData;

      if (this.cartServiceData.FirstOrderFlag == 'Y') {
        if ((this.cartServiceData.amount > this.mandatedetails[0].amount)) {
          this.Loader.hide();
          this.CallAlertModal("Your order amount exceeds the allowed limit for selected mandate. Unfortunately, you cannot proceed with this transaction.")
        } else {
          this.SipBseProcess();
        }
      } else {
        this.SipBseProcess();
      }

      // }
    }
    else if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.page == "lumpsumbse") {
      debugger
      console.log("summaryserviceData: " + JSON.stringify(this.cartServiceData));
      this.lumpsumBSEData = this.cartServiceData;
      console.log("Mandate Details", this.mandatedetails);
      if (parseInt(this.EncrdecrService.getDecr(this.cartServiceData.Amount)) > this.mandatedetails[0].Amount) {
        this.Loader.hide();
        this.CallAlertModal("Your order amount exceeds the allowed limit for selected mandate. Unfortunately, you cannot proceed with this transaction.")
      } else {
        this.LumpSumBseProcess();
      }

    }
    else if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.length == 1) {
      if (this.cartServiceData[0].page == "cartLumpsum" || this.cartServiceData[0].page == "cartSIP") {
        if (parseInt(this.EncrdecrService.getDecr(this.cartServiceData[0].Amount)) > this.mandatedetails[0].Amount) {
          this.Loader.hide();
          this.CallAlertModal("Your order amount exceeds the allowed limit for selected mandate. Unfortunately, you cannot proceed with this transaction.")
        } else {
          this.CartBSEProcess();
        }
      }
    }
    else if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.length > 1) {
      debugger
      // if (this.cartServiceData[0].page == "cartLumpsum" || this.cartServiceData[0].page == "cartSIP") {
      let PayableAmountCart = 0;
      this.cartServiceData.forEach(element => {
        PayableAmountCart += parseFloat(this.EncrdecrService.getDecr(element.Amount));
      });
      if (PayableAmountCart > this.mandatedetails[0].Amount) {
        this.Loader.hide();
        this.CallAlertModal("Your order amount exceeds the allowed limit for selected mandate. Unfortunately, you cannot proceed with this transaction.");
      }
      else {
        this.CartBSEProcess();
      }
      // }
    }
  }
  ProceedPaymentGateway() {
    debugger;
if(this.selectedPaymentMethod=="UPI")
  {
    this.UPIFormSubmitted = true;
      if (this.UPIForm.invalid) {
        this.Loader.hide();
        return;
      } 
  }


    this.disablePaymentgateway = true;
    this.Loader.show();
    this.FailureReason = "";
    let date = new Date();
    let rid = date.getFullYear().toString() + date.getMonth().toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString() + this.G_ClientBasicInfoId;
    console.log("Payment mode:", this.selectedPaymentMethod);
    this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabled');
    if (this.isShowAutoPay) {
      this.renderer.addClass(this.AutoPayMainElement.nativeElement, 'disabled');
    }
    if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && (this.cartServiceData.page == "lumpsumbse" || this.cartServiceData.page == "sipbse")) {
      // Dynamic key to be added
      let newKey = 'PaymentType';
      let newValue = this.selectedPaymentMethod;

      let newKey2 = 'OTMMandateId';
      let newValue2 = "";
      this.SelectedMandateCode;
      // Add the key-value pair dynamically
      this.cartServiceData[newKey] = newValue;
      this.cartServiceData[newKey2] = newValue2;

      this.cartServiceData["PaymentReferenceID"] = rid;

      console.log("Updated cart", this.cartServiceData);
    }


    if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.page == "sipbse") {
      console.log("summaryserviceData: " + JSON.stringify(this.cartServiceData));
      let newKey = 'PaymentType';
      let newValue = this.selectedPaymentMethod;
      let newKey2 = 'OTMMandateId';
      let newValue2 = "";
      // Add the key-value pair dynamically
      this.cartServiceData[newKey] = newValue;
      this.cartServiceData[newKey2] = newValue2;
      this.cartServiceData["PaymentReferenceID"] = rid;

      // if (this.cartServiceData.page == "lumpsumbse") {
      this.sipBSEData = this.cartServiceData;
      this.SipBseProcess();
      // if (this.cartServiceData.FirstOrderFlag == 'Y') {
      //   if ((this.cartServiceData.amount > this.mandatedetails.amount)) {
      //     this.CallAlertModal("Your order amount exceeds the allowed limit for selected mandate. Unfortunately, you cannot proceed with this transaction.")
      //   } else {
      //     this.SipBseProcess();
      //   }
      // } else {
      //   this.SipBseProcess();
      // }

      // }
    }
    else if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.page == "lumpsumbse") {
      console.log("summaryserviceData: " + JSON.stringify(this.cartServiceData));
      this.lumpsumBSEData = this.cartServiceData
      this.LumpSumBseProcess();
    }
    else if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.length == 1) {
      if (this.cartServiceData[0].page == "cartLumpsum" || this.cartServiceData[0].page == "cartSIP") {
        this.CartBSEProcess(rid);
      }
    }
    else if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.length > 1) {
      if (this.cartServiceData[0].page == "cartLumpsum" || this.cartServiceData[0].page == "cartSIP") {
        this.CartBSEProcess(rid);
      }
    }
  }
  SetMandate(selectedMandate) {
    if (selectedMandate === "X") {
      let d = this.ClientMandateList.filter(a => a.MandateType == 'NachMandate');
      if (d.length > 0) {
        this.sipForm.controls["SIPMode"].setValue("XSIP");
        this.ClientMandateListShow = d;
      }
      else {
        this.ClientMandateListShow = [];
        // this.GenerateNewMandate();
      }

    }
    else if (selectedMandate === "E") {
      let d = this.ClientMandateList.filter(a => a.MandateType == 'EMandate');
      if (d.length > 0) {
        this.sipForm.controls["SIPMode"].setValue("ESIP");
        this.ClientMandateListShow = d;
      }
      else {
        this.ClientMandateListShow = [];
        // this.GenerateNewMandate();
      }
    }
  }
  goToOrderBook() {
    debugger
    this.Loader.show();
    // $(".modal").attr("inert", "true");

    // $(".modal").find(':focus').blur();
    if (!isNullOrUndefined(this.lumpsumBSEData)) {
      if (this.lumpsumBSEData.Flag != "FromOrderBookReport") {
        $(".modal").modal("hide");
        this.bsModalRef.hide();
        this.router.navigate(['reports-new/orderbook-report']);
      }
      else {
        this.bsModalRef.content.onClose.next(true);
        this.bsModalRef.hide();
      }
    } else {
      $(".modal").modal("hide");
      this.bsModalRef.hide();
      this.router.navigate(['reports-new/orderbook-report']);
    }
  }

  goToTransactPage() {
    debugger
    this.Loader.show();
    if (isArray(this.cartServiceData) || this.cartServiceData.page == "cartLumpsum" || this.cartServiceData.page == "cartSIP") {
      window.location.href = '/transaction-new-latest/lumpsum';
    }
    else {
      if (this.cartServiceData.page == "lumpsumbse") {
        window.location.href = '/transaction-new-latest/lumpsum';
      }
      else if (this.cartServiceData.page == "sipbse") {
        window.location.href = '/transaction-new-latest/sip';
      }
    }
  }
  //Added by tishya
  paymentModeSelected() {
    debugger
    this.selectedPaymentMethod = this.TempselectedPaymentMethod;
    let paymentMode = this.selectedPaymentMethod;
    if (paymentMode == "NEFT/RTGS") {
      // $( "#AutoPay" ).prop('disabled',true);
      // $( "#PaymentGateway" ).prop('disabled',true);
      if (this.isShowAutoPay) {
        this.renderer.addClass(this.AutoPayMainElement.nativeElement, 'disabled');
      }

      this.renderer.addClass(this.RazorPayMainElement.nativeElement, 'disabled');
      this.renderer.addClass(this.UPIPayMainElement.nativeElement, 'disabled');

      this.ProceedNEFTRTGS();
      // this.renderer.addClass(this.NEFTRTGSMainElement.nativeElement, 'disabled');
    }
    else if (paymentMode == "AutoPay") {

      if (this.collapseElement) {
        this.renderer.removeClass(this.collapseElement1.nativeElement, 'collapse'); // Remove the 'collapse' class
        this.renderer.addClass(this.collapseElement1.nativeElement, 'show');  // Add the 'show' class to expand it
      }

      this.renderer.removeClass(this.collapseElement3.nativeElement, 'show'); // Remove the 'collapse' class
      this.renderer.addClass(this.collapseElement3.nativeElement, 'collapse');
      this.renderer.removeClass(this.collapseUPIElement3.nativeElement, 'show'); // Remove the 'collapse' class
      this.renderer.addClass(this.collapseUPIElement3.nativeElement, 'collapse');

    }
    else if (paymentMode == "PaymentGateway") {
      if (this.collapseElement) {
        this.renderer.removeClass(this.collapseElement3.nativeElement, 'collapse'); // Remove the 'collapse' class
        this.renderer.addClass(this.collapseElement3.nativeElement, 'show');  // Add the 'show' class to expand it
      }

      this.renderer.removeClass(this.collapseElement1.nativeElement, 'show'); // Remove the 'collapse' class
      this.renderer.addClass(this.collapseElement1.nativeElement, 'collapse');
      this.renderer.removeClass(this.collapseUPIElement3.nativeElement, 'show'); // Remove the 'collapse' class
      this.renderer.addClass(this.collapseUPIElement3.nativeElement, 'collapse');
    }
    else if (paymentMode == "UPI") {
      if (this.collapseElement) {
        this.renderer.removeClass(this.collapseUPIElement3.nativeElement, 'collapse'); // Remove the 'collapse' class
        this.renderer.addClass(this.collapseUPIElement3.nativeElement, 'show');  // Add the 'show' class to expand it
      }

      this.renderer.removeClass(this.collapseElement1.nativeElement, 'show'); // Remove the 'collapse' class
      this.renderer.addClass(this.collapseElement1.nativeElement, 'collapse');
      this.renderer.addClass(this.collapseElement3.nativeElement, 'collapse');  // Add the 'show' class to expand it
      this.renderer.removeClass(this.collapseElement3.nativeElement, 'show'); // Remove the 'collapse' class

    }

    if (paymentMode == 'CHEQUEMODE') {
      if (this.collapseElement) {
        this.renderer.removeClass(this.collapseElement7.nativeElement, 'collapse'); // Remove the 'collapse' class
        this.renderer.addClass(this.collapseElement7.nativeElement, 'show');  // Add the 'show' class to expand it
      }
      this.ChequeForm.controls["CHEQUENO"].setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern(NumberOnly)])
      this.ChequeForm.controls["CHEQUENO"].updateValueAndValidity();
      this.ChequeForm.controls["chqDate"].setValidators(Validators.required)
      this.ChequeForm.controls["chqDate"].updateValueAndValidity()
      if (this.BankListCheque.length == 1) {
        this.selectedChequeAccount = this.BankListCheque[0].TEXTFIELD;
        $('.CustomSelectChequeBank').val(this.selectedChequeAccount).trigger('change');
      }
    }
    if (paymentMode == 'CHEQUE') {
      // this.DisableCollapseEvent(paymentMode)
      let bankData = this.selectedBankAccount?.split('|') || [];
      let missingFields: string[] = [];
      if (!bankData[0]) {
        missingFields.push('Account Number');
      }
      if (!bankData[1]) {
        missingFields.push('IFSC Code');
      }
      if (!bankData[3]) {
        missingFields.push('Bank Code');
      }

      if (missingFields.length > 0) {
        const message = `Missing: ${missingFields.join(', ')}`;
        this.CallAlertOKModal(message); // or show this on the HTML instead of alert
      } else {
        // if(paymentMode == 'NODAL'){
        //   this.ProceedNEFTRTGS();
        // }
        // else{
        if (paymentMode == "CHEQUE" || paymentMode == "CHEQUEMODE") {
          this.VerifyChequeNumber();
        } else {
          this.ConfirmTransactPopup(`Do you want to proceed with ${paymentMode} payment mode ?`)
        }
        // }   
        return;
        //this.ProceedNEFTRTGS();
      }
    }
  }

  CallAlertOKModal(msg: any) {
    $("#AlertModalOkmodels").modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertModalOkContentmodels').text(msg);
  }

  ProceedToPaymentGateway() {
    if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && (this.cartServiceData.page == "lumpsumbse" || this.cartServiceData.page == "sipbse")) {
      // Dynamic key to be added
      let newKey = 'PaymentType';
      let newValue = this.selectedPaymentMethod;
      let newKey2 = 'OTMMandateId';
      let newValue2 = "";
      // Add the key-value pair dynamically
      this.cartServiceData[newKey] = newValue;
      this.cartServiceData[newKey2] = newValue2;
      console.log("Updated cart", this.cartServiceData);
    }
    if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.page == "sipbse") {
      console.log("summaryserviceData: " + JSON.stringify(this.cartServiceData));
      // if (this.cartServiceData.page == "lumpsumbse") {
      this.sipBSEData = this.cartServiceData;
      if (this.cartServiceData.FirstOrderFlag == 'Y') {
        if ((this.cartServiceData.amount > this.mandatedetails.amount)) {
          this.CallAlertModal("Your order amount exceeds the allowed limit for selected mandate. Unfortunately, you cannot proceed with this transaction.")
        } else {
          this.SipBseProcess();
        }
      } else {
        this.SipBseProcess();
      }

      // }
    }
    else if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.page == "lumpsumbse") {
      console.log("summaryserviceData: " + JSON.stringify(this.cartServiceData));
      this.lumpsumBSEData = this.cartServiceData;
      if (this.cartServiceData.amount > this.mandatedetails.amount) {
        this.CallAlertModal("Your order amount exceeds the allowed limit for selected mandate. Unfortunately, you cannot proceed with this transaction.")
      } else {
        this.LumpSumBseProcess();
      }

    }
    else if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.length == 1) {
      if (this.cartServiceData[0].page == "cartLumpsum" || this.cartServiceData[0].page == "cartSIP") {
        this.CartBSEProcess();
      }
    }
    else if (!isNullOrUndefined(this.cartServiceData) && this.cartServiceData != "" && this.cartServiceData.length > 1) {
      if (this.cartServiceData[0].page == "cartLumpsum" || this.cartServiceData[0].page == "cartSIP") {
        this.CartBSEProcess();
      }
    }
  }

  // ChequeStatus(msg: any, flag: any, cart: any) {
  //   this.ChequeOrderStatus = flag == 0
  //   this.HideChequeSuccessMessage = ['2', '5'].includes(cart);
  //   if (this.HideChequeSuccessMessage) {
  //     this.SuccessChequeMessage = this.PGFailedFormatter(msg);
  //     setTimeout(() => {
  //       const element = document.getElementById("chequeMessage");
  //       if (element) {
  //         element.innerHTML = "The challan has been sent to your registered Email ID. Kindly issue a cheque from the above mentioned account along with the challan towards payment of your Mutual Fund order in favour of \"Indian Clearing Corporation Limited\"";
  //       } else {
  //         console.log("Element not found!");
  //       }
  //     }, 0);
  //   }

  //   this.renderer.addClass(this.collapseElement7.nativeElement, 'collapse'); // Remove the 'collapse' class
  //   this.renderer.removeClass(this.collapseElement7.nativeElement, 'show');
  //   this.ShowBTNText = "Go to Order Book"
  // }

  SendReqForChallan(orderno: any, amount: any, UccCode: any) {

    this.Loader.show();
    // this.finalLoader = true;

    // if(this.selectedChequeAccount){
    let allBankDetail = this.selectedChequeAccount.split("|");
    let allOrders = orderno.split(",");

    //   let reqForBankData = {
    //     IFSCCode: allBankDetail[1]
    //   }

    // this.transactionBSe.GetBankDetailsByIFSCForChallan(reqForBankData).subscribe((data: any) => {
    //   console.warn(reqForBankData)
    //   debugger
    //   console.warn(data)
    //   if (data.ArrayOfResponse.length > 0) {

    // let bankData = data.ArrayOfResponse;

    let result_chq = {
      ClientCode: UccCode,
      OrderNo: allOrders,
      TotalAmount: amount,
      IFSCCode: allBankDetail[1],
      AccNo: allBankDetail[0],
      ChequeNo: this.ChequeForm.get('CHEQUENO').value,
      ChequeDate: this.ChequeForm.get('chqDate').value,
      ChequeAmount: amount,
      DepositBank: allBankDetail[3],
      // Filler1: bankData.BranchName,
      // Filler2: bankData.CityName
    }

    this.transactionBSe.InvestToLumpsumCheque(result_chq).subscribe((data: any) => {
      // console.warn(result_chq)

      this.Loader.hide();
      // this.finalLoader = false;this.Loader.hide();

      debugger

      // let data = {
      //   ArrayOfResponse : [{
      //     Status : "0"
      //   }],
      //   Message : ""
      // }

      // console.warn(data)
      if (data) {
        if (data.ArrayOfResponse.length > 0) {

          if (data.ArrayOfResponse[0].Status == "0") {

            this.CallSuccessFailAlertModal("Challan generated successfully");

          }

        }

        else {

          this.PaymentModel(data.Message);

          // this.ChequeStatus(RespoMsg, 0, '6');

        }
      }
    })
    // }
    // else {
    //   console.log("Failed to fetch Bank data");
    // }
    // })
    // }
  }

  PaymentModel(msg: any) {
    this.isShowPaymentModel = true;
    $("#ChequePaymentFailModeAlertModal").modal({ backdrop: "static", keyboard: false });
    $("#ChequePaymentFailModeAlertModalContent").text(msg);
  }

  RedirectBackToPayment() {
    debugger
    this.isShowPaymentModel = false;
    // this.router.navigateByUrl('/transaction-new/net-banking-payment');
    $('#ChequePaymentFailModeAlertModal').modal('hide');
  }


  PGFailedFormatter(failureReason: string) {
    if (!failureReason) return;
    return failureReason.replace(/\|/g, "").replace(/undefined/g, "");
  }

  SendMail(Flag: string, JsonRequest?: any, CreatedBy?: any, UserType?: any) {
    debugger;
    let request: any;
    console.log("SendMail Request: " + JSON.stringify(JsonRequest));
    switch (Flag) {
      case "SIPBse":
        request = {
          Flag: "SIP",
          Amount: JsonRequest.page == "cartSIP" ? this.EncrdecrService.getDecr(JsonRequest.Amount) : this.EncrdecrService.getDecr(this.sipBSEData.Amount),
          SchemeName: JsonRequest.page == "cartSIP" ? JsonRequest.FundName : this.sipBSEData.FundName,
          Frequecy: JsonRequest.page == "cartSIP" ? JsonRequest.Frequecy : this.sipBSEData.Frequency,
          FolioNumber: JsonRequest.page == "cartSIP" ? JsonRequest.FolioNumber == "New Folio"
            ? "To be assigned."
            : JsonRequest.FolioNumber :
            this.sipBSEData.FolioNumber == "New Folio"
              ? "To be assigned."
              : this.sipBSEData.FolioNumber,
          StartDate: JsonRequest.page == "cartSIP" ? JsonRequest.SIPStartDate : this.sipBSEData.SIPStartDate,
          EndDate: JsonRequest.page == "cartSIP" ? JsonRequest.EndDate : this.sipBSEData.SIPEndDate,
          Status: "Initiated",
          ClientName: this.sipBSEData?.ClientName,
          OrderNo: JsonRequest.OrderNo,
          ClientBasicInfoId: JsonRequest.page == "cartSIP" ? JsonRequest.ClientBasicInfoId : this.sipBSEData.ClientBasicInfoID,
          InvestMentAccountNo: JsonRequest.page == "cartSIP" ? `${JsonRequest.UccCode} (UCC)` : `${this.sipBSEData.UccCode} (UCC)`,
          CreatedBy: CreatedBy,
          UserType: UserType,
          UniqueId: JsonRequest.UniqueId
        };

        break;
      case "LumpsumBSE":
        request = {
          Flag: "Lumpsum",
          Amount: JsonRequest.page == "cartLumpsum" ? this.EncrdecrService.getDecr(JsonRequest.Amount) : this.lumpsumBSEData.TotalAmount,
          SchemeName: JsonRequest.page == "cartLumpsum" ? JsonRequest.FundName : this.lumpsumBSEData.FundName,
          FolioNumber:
            JsonRequest.page == "cartLumpsum" ? JsonRequest.FolioNumber == "New Folio"
              ? "To be assigned."
              : JsonRequest.FolioNumber : this.lumpsumBSEData.FolioNumber == "New Folio"
              ? "To be assigned."
              : this.lumpsumBSEData.FolioNumber,
          Status: "Initiated",
          ClientName: this.lumpsumBSEData?.ClientName,
          ClientBasicInfoId: JsonRequest.page == "cartLumpsum" ? this.G_ClientBasicInfoId : this.lumpsumBSEData.ClientBasicInfoId,
          InvestMentAccountNo: JsonRequest.page == "cartLumpsum" ? `${this.RazorPayUCC} (UCC)` : `${this.lumpsumBSEData.UccCode} (UCC)`,
          OrderNo: JsonRequest.OrderNo,
          CreatedBy: CreatedBy,
          UserType: UserType,
          UniqueId: JsonRequest.UniqueId
        };
        break;



      // case "SWPBse":
      //   request = {
      //     Flag: "SWP",
      //     Amount: this.EncrdecrService.getDecr(this.swpBSEData.Amount),
      //     FromScheme: this.swpBSEData.FromSchemeName,
      //     Frequecy: this.swpBSEData.Frequency,
      //     FolioNumber: this.swpBSEData.FolioNumber,
      //     StartDate: this.swpBSEData.SIPStartDate,
      //     EndDate: this.swpBSEData.SIPEndDate,
      //     Status: "Initiated",
      //     ClientName: this.swpBSEData.ClientName,
      //     ClientBasicInfoId: this.swpBSEData.ClientBasicInfoId,
      //     InvestMentAccountNo: `${this.swpBSEData.UccCode} (UCC)`,
      //   };
      //   break;

      //   let SWPFrequency = "";
      //   switch (this.swpNSEData.Frequency) {
      //     case "OM":
      //       SWPFrequency = "Monthly";
      //       break;
      //     case "OW":
      //     case "WD":
      //       SWPFrequency = "Once in a week";
      //       break;
      //     case "Q":
      //       SWPFrequency = "Quarterly";
      //       break;
      //     case "H":
      //       SWPFrequency = "Half Yearly";
      //       break;
      //     case "Y":
      //       SWPFrequency = "Yearly";
      //       break;
      //     case "BZ":
      //       SWPFrequency = "Business Day";
      //     default:
      //       break;
      //   }
      //   request = {
      //     Flag: "SWP",
      //     Amount: this.swpNSEData.SwpAmount,
      //     FromScheme: this.swpNSEData.SchemeName,
      //     Frequecy: SWPFrequency,
      //     FolioNumber: this.swpNSEData.FolioNo,
      //     StartDate: this.swpNSEData.StartSWPDate,
      //     EndDate: this.swpNSEData.ENDSTPDate,
      //     Status: "Initiated",
      //     ClientName: this.swpNSEData.ClientName,
      //     ClientBasicInfoId: this.swpNSEData.ClientBasicInfoId,
      //     InvestMentAccountNo: `${this.swpNSEData.UCCCode} (IIN)`,
      //   };
      //   break;

      // case "STPBse":
      //   request = {
      //     Flag: "STP",
      //     Amount: this.EncrdecrService.getDecr(this.stpBSEData.Amount),
      //     FromScheme: this.stpBSEData.FromSchemeName,
      //     ToScheme: this.stpBSEData.ToSchemeName,
      //     Frequecy: this.stpBSEData.Frequency,
      //     FolioNumber: this.stpBSEData.FolioNumber,
      //     StartDate: this.stpBSEData.SIPStartDate,
      //     EndDate: this.stpBSEData.SIPEndDate,
      //     Status: "Initiated",
      //     ClientName: this.stpBSEData.ClientName,
      //     ClientBasicInfoId: this.stpBSEData.ClientBasicInfoId,
      //     InvestMentAccountNo: `${this.stpBSEData.UccCode} (UCC)`,
      //   };
      //   break;

      //   let STPFrequency = "";
      //   switch (this.stpNSEData.Frequency) {
      //     case "OM":
      //       STPFrequency = "Monthly";
      //       break;
      //     case "OW":
      //     case "WD":
      //       STPFrequency = "Once in a Week";
      //       break;
      //     case "Q":
      //       STPFrequency = "Quarterly";
      //       break;
      //     case "H":
      //       STPFrequency = "Half Yearly";
      //       break;
      //     case "Y":
      //       STPFrequency = "Yearly";
      //       break;
      //     case "BZ":
      //       STPFrequency = "Business Day";
      //     default:
      //       break;
      //   }
      //   request = {
      //     Flag: "STP",
      //     Amount: this.stpNSEData.STPAMount,
      //     FromScheme: this.stpNSEData.FromScheme,
      //     ToScheme: this.stpNSEData.ToScheme,
      //     Frequecy: STPFrequency,
      //     FolioNumber: this.stpNSEData.FolioNo,
      //     StartDate: this.stpNSEData.StartSTPDate,
      //     EndDate: this.stpNSEData.ENDSTPDate,
      //     Status: "Initiated",
      //     ClientName: this.stpNSEData.ClientName,
      //     ClientBasicInfoId: this.stpNSEData.ClientBasicInfoId,
      //     InvestMentAccountNo: `${this.stpNSEData.UCCCode} (IIN)`,
      //   };
      //   break;
      // case "SwitchBSE":
      //   let SwitchUnitsBSE = "";
      //   if (this.switchBSEData.RdbSwitchBy == "Units") {
      //     SwitchUnitsBSE = this.switchBSEData.SwitchUnits;
      //   } else if (this.switchBSEData.RdbSwitchBy == "AllUnits") {
      //     if (
      //       this.switchBSEData.AvailableUnits != null &&
      //       this.switchBSEData.AvailableUnits != undefined &&
      //       this.switchBSEData.AvailableUnits != ""
      //     ) {
      //       SwitchUnitsBSE = `All Units (${this.switchBSEData.AvailableUnits})`;
      //     } else {
      //       SwitchUnitsBSE = `All Units`;
      //     }
      //   }

      //   request = {
      //     Flag: "Switch",
      //     Amount: this.switchBSEData.AvailableAmount,
      //     FromScheme: this.switchBSEData.FromSchemeName,
      //     ToScheme: this.switchBSEData.ToSchemeName,
      //     SwitchUnits: SwitchUnitsBSE,
      //     FolioNumber: this.switchBSEData.FolioNumber,
      //     SwitchAmount: this.switchBSEData.OrderVal,
      //     Status: "Initiated",
      //     ClientName: this.switchBSEData.ClientName,
      //     ClientBasicInfoId: this.switchBSEData.ClientBasicInfoId,
      //     InvestMentAccountNo: `${this.switchBSEData.UccCode} (UCC)`,
      //   };
      //   break;

      //   let SwitchUnit_Amount = "";
      //   if (this.switchNSEData.radiotype == "1") {
      //     SwitchUnit_Amount = this.switchNSEData.InstallAmountSwitch;
      //   } else if (this.switchNSEData.radiotype == "2") {
      //     if (
      //       this.switchNSEData.InstallAmountSwitch != null &&
      //       this.switchNSEData.InstallAmountSwitch != undefined &&
      //       this.switchNSEData.InstallAmountSwitch != ""
      //     ) {
      //       SwitchUnit_Amount = `All Units (${this.switchNSEData.InstallAmountSwitch})`;
      //     } else {
      //       SwitchUnit_Amount = `All Units`;
      //     }
      //   } else if (this.switchNSEData.radiotype == "0") {
      //     SwitchUnit_Amount = this.switchNSEData.InstallAmountSwitch;
      //   }
      //   request = {
      //     Flag: "Switch",
      //     Amount: this.switchNSEData.AvailableAmount,
      //     FromScheme: this.switchNSEData.FromSchemeName,
      //     ToScheme: this.switchNSEData.ToSchemeName,
      //     SwitchUnits:
      //       this.switchNSEData.radiotype == "2" ||
      //       this.switchNSEData.radiotype == "1"
      //         ? SwitchUnit_Amount
      //         : "",
      //     FolioNumber: this.switchNSEData.FolioNo,
      //     SwitchAmount:
      //       this.switchNSEData.radiotype == "0" ? SwitchUnit_Amount : "",
      //     Status: "Initiated",
      //     ClientName: this.switchNSEData.ClientName,
      //     ClientBasicInfoId: this.switchNSEData.ClientBasicInfoId,
      //     InvestMentAccountNo: `${this.switchNSEData.UCCCode} (IIN)`,
      //   };
      //   break;

      // case "RedeemBSE":
      // let reddemUnits_Amount = "";
      // if (this.redeemBSEData.RdbSwitchBy == "Units") {
      //   reddemUnits_Amount = this.redeemBSEData.Quantity;
      // } else if (this.redeemBSEData.RdbSwitchBy == "AllUnits") {
      //   if (
      //     this.redeemBSEData.AvailableUnits != null &&
      //     this.redeemBSEData.AvailableUnits != undefined &&
      //     this.redeemBSEData.AvailableUnits != ""
      //   ) {
      //     reddemUnits_Amount = `All Units (${this.redeemBSEData.AvailableUnits})`;
      //   } else {
      //     reddemUnits_Amount = `All Units`;
      //   }
      // }
      // request = {
      //   Flag: "Redemption",
      //   Amount: this.redeemBSEData.AvailableAmount,
      //   SchemeName: this.redeemBSEData.FromSchemeName,

      //   RedemptionUnits: reddemUnits_Amount,
      //   FolioNumber: this.redeemBSEData.FolioNumber,
      //   RedemptionAmount:
      //     this.redeemBSEData.RdbSwitchBy == "Amount"
      //       ? this.redeemBSEData.Quantity
      //       : "",
      //   Status: "Initiated",
      //   ClientName: this.redeemBSEData.ClientName,
      //   ClientBasicInfoId: this.redeemBSEData.ClientBasicInfoID,
      //   InvestMentAccountNo: `${this.redeemBSEData.UccCode} (UCC)`,
      // };
      // break;
      default:
        break;
    }
    debugger;
    console.log("Request : ", request);
    let dataRequest: any;
    dataRequest = JSON.stringify(request);
    this.clientProfileService
      .SendTransactionMail(dataRequest)
      .subscribe((res: any) => {
        let data = JSON.parse(this.EncrdecrService.getDecr(res));
        console.log(data);
      });
  }

  SendRejectedMail(Flag: string, JsonRequest?: any, CreatedBy?: any, UserType?: any) {
    debugger;
    let request: any;
    console.log("Rejected Mail Request: " + JSON.stringify(JsonRequest));
    switch (Flag) {
      case "LumpsumBSE":
        request = {
          Flag: "LumpsumRejected",
          Amount: JsonRequest.page == "cartLumpsum" ? this.EncrdecrService.getDecr(JsonRequest.Amount) : this.lumpsumBSEData.Flag == "FromOrderBookReport" ? this.EncrdecrService.getDecr(this.lumpsumBSEData.Amount) : this.lumpsumBSEData.TotalAmount,
          SchemeName: JsonRequest.page == "cartLumpsum" ? JsonRequest.FundName : this.lumpsumBSEData.Flag == "FromOrderBookReport" ? this.lumpsumBSEData.SchemeName : this.lumpsumBSEData.FundName,
          FolioNumber:
            JsonRequest.page == "cartLumpsum" ? JsonRequest.FolioNumber == "New Folio"
              ? "To be assigned."
              : JsonRequest.FolioNumber : this.lumpsumBSEData.FolioNumber == "New Folio"
              ? "To be assigned."
              : this.lumpsumBSEData.FolioNumber,
          Status: "Initiated",
          ClientName: this.lumpsumBSEData?.ClientName,
          ClientBasicInfoId: JsonRequest.page == "cartLumpsum" ? this.G_ClientBasicInfoId : this.lumpsumBSEData.ClientBasicInfoId,
          InvestMentAccountNo: JsonRequest.page == "cartLumpsum" ? `${this.RazorPayUCC} (UCC)` : `${this.lumpsumBSEData.UccCode} (UCC)`,
          Reason: JsonRequest.Message,
          CreatedBy: CreatedBy,
          UserType: UserType,
          UniqueId: JsonRequest.UniqueId
        };
        break;

      case "SIPBSE":
        request = {
          Flag: "SIPRejected",
          Amount: JsonRequest.page == "cartSIP" ? this.EncrdecrService.getDecr(JsonRequest.Amount) : this.EncrdecrService.getDecr(this.sipBSEData.Amount),
          SchemeName: JsonRequest.page == "cartSIP" ? JsonRequest.FundName : this.sipBSEData.FundName,
          Frequecy: JsonRequest.page == "cartSIP" ? JsonRequest.Frequecy : this.sipBSEData.Frequency,
          FolioNumber: JsonRequest.page == "cartSIP" ? JsonRequest.FolioNumber == "New Folio"
            ? "To be assigned."
            : JsonRequest.FolioNumber :
            this.sipBSEData.FolioNumber == "New Folio"
              ? "To be assigned."
              : this.sipBSEData.FolioNumber,
          StartDate: JsonRequest.page == "cartSIP" ? JsonRequest.SIPStartDate : this.sipBSEData.SIPStartDate,
          EndDate: JsonRequest.page == "cartSIP" ? JsonRequest.EndDate : this.sipBSEData.SIPEndDate,
          Status: "Initiated",
          ClientName: this.sipBSEData?.ClientName,
          ClientBasicInfoId: JsonRequest.page == "cartSIP" ? JsonRequest.ClientBasicInfoId : this.sipBSEData.ClientBasicInfoID,
          InvestMentAccountNo: JsonRequest.page == "cartSIP" ? `${JsonRequest.UccCode} (UCC)` : `${this.sipBSEData.UccCode} (UCC)`,
          Reason: JsonRequest.Message,
          CreatedBy: CreatedBy,
          UserType: UserType
        };
        break;


      // case "SWPBse":
      //   request = {
      //     Flag: "SWPRejected",
      //     Amount: this.EncrdecrService.getDecr(this.swpBSEData.Amount),
      //     FromScheme: this.swpBSEData.FromSchemeName,
      //     Frequecy: this.swpBSEData.Frequency,
      //     FolioNumber: this.swpBSEData.FolioNumber,
      //     StartDate: this.swpBSEData.SIPStartDate,
      //     EndDate: this.swpBSEData.SIPEndDate,
      //     Status: "Rejected",
      //     ClientName: this.swpBSEData.ClientName,
      //     ClientBasicInfoId: this.swpBSEData.ClientBasicInfoId,
      //     InvestMentAccountNo: `${this.swpBSEData.UccCode} (UCC)`,
      //     Reason: Message,
      //   };
      //   break;

      // case "SwitchBSE":
      //   let SwitchUnitsBSE = "";
      //   if (this.switchBSEData.RdbSwitchBy == "Units") {
      //     SwitchUnitsBSE = this.switchBSEData.SwitchUnits;
      //   } else if (this.switchBSEData.RdbSwitchBy == "AllUnits") {
      //     if (
      //       this.switchBSEData.AvailableUnits != null &&
      //       this.switchBSEData.AvailableUnits != undefined &&
      //       this.switchBSEData.AvailableUnits != ""
      //     ) {
      //       SwitchUnitsBSE = `All Units (${this.switchBSEData.AvailableUnits})`;
      //     } else {
      //       SwitchUnitsBSE = `All Units`;
      //     }
      //   }

      //   request = {
      //     Flag: "SwitchRejected",
      //     Amount: this.switchBSEData.AvailableAmount,
      //     FromScheme: this.switchBSEData.FromSchemeName,
      //     ToScheme: this.switchBSEData.ToSchemeName,
      //     SwitchUnits: SwitchUnitsBSE,
      //     FolioNumber: this.switchBSEData.FolioNumber,
      //     SwitchAmount: this.switchBSEData.OrderVal,
      //     Status: "Rejected",
      //     ClientName: this.switchBSEData.ClientName,
      //     ClientBasicInfoId: this.switchBSEData.ClientBasicInfoId,
      //     InvestMentAccountNo: `${this.switchBSEData.UccCode} (UCC)`,
      //     Reason: Message,
      //   };
      //   break;


      // case "RedeemBSE":
      // let reddemUnits_Amount = "";
      // if (this.redeemBSEData.RdbSwitchBy == "Units") {
      //   reddemUnits_Amount = this.redeemBSEData.Quantity;
      // } else if (this.redeemBSEData.RdbSwitchBy == "AllUnits") {
      //   if (
      //     this.redeemBSEData.AvailableUnits != null &&
      //     this.redeemBSEData.AvailableUnits != undefined &&
      //     this.redeemBSEData.AvailableUnits != ""
      //   ) {
      //     reddemUnits_Amount = `All Units (${this.redeemBSEData.AvailableUnits})`;
      //   } else {
      //     reddemUnits_Amount = `All Units`;
      //   }
      // }
      // request = {
      //   Flag: "RedemptionRejected",
      //   Amount: this.redeemBSEData.AvailableAmount,
      //   SchemeName: this.redeemBSEData.FromSchemeName,

      //   RedemptionUnits: reddemUnits_Amount,
      //   FolioNumber: this.redeemBSEData.FolioNumber,
      //   RedemptionAmount:
      //     this.redeemBSEData.RdbSwitchBy == "Amount"
      //       ? this.redeemBSEData.Quantity
      //       : "",
      //   Status: "Rejected",
      //   ClientName: this.redeemBSEData.ClientName,
      //   ClientBasicInfoId: this.redeemBSEData.ClientBasicInfoID,
      //   InvestMentAccountNo: `${this.redeemBSEData.UccCode} (UCC)`,
      //   Reason: Message,
      // };
      // break;

      default:
        break;
    }
    debugger;
    console.log("Request : ", request);
    let dataRequest: any;
    dataRequest = JSON.stringify(request);
    this.clientProfileService
      .SendTransactionMail(dataRequest)
      .subscribe((res: any) => {
        let data = JSON.parse(this.EncrdecrService.getDecr(res));
        console.log(data);
      });
  }

  //#region Cart_Checkout_Click Clevertap
  captureCartCheckout(amount: String, schemeName: String, paymentMode: String) {
    const values = {
      Amount: amount,
      SchemeName: schemeName,
      PaymentMode: paymentMode
    }

    this.Clevertap.recordEvent('Cart_Checkout_Click', values);
  }
  //#endregion

  //Siddhesh_23072026
  OpenInternetBankingPage(html: string) {
    var newWindow = window.open();
    newWindow.document.write(html);
  }

  GetNetBankingPageIncred(OrderNumber: any, totalAmount, PaymentType: string, vpaid: string, UccCode) {
    debugger
    this.Loader.show();
    if(PaymentType == "PaymentGateway")
    {
      PaymentType="NODAL";
      vpaid="";
    }
    let request = {
      clientcode: UccCode,
      modeofpayment: PaymentType,
      accountnumber: this.AcccountNumber_PG,
      ifsc: this.IFSCCode,
      ordernumber: OrderNumber,
      totalamount: totalAmount,
      vpaid: vpaid,
      BankCode: this.BankCode
    }
    debugger
    this.transaction.GetNetBankingPaymentPageIncred(request, this.rid,
      this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX')),
      this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"))).subscribe(
        (result: any) => {
          this.Loader.hide();
          let res = JSON.parse(this.EncrdecrService.getDecr(result));
          if (res.Message != null && res.Message != '' && res.Message.indexOf('Not Authorized') > -1) {
            this.Loader.hide();
            this.Logout.LogoutUser();
            return;
          } else {
            debugger;
            if (PaymentType == "NODAL") {
              if (res?.ReturnMessage != undefined) {

                sessionStorage.setItem("rmEEfE4uMCS8AtFl", this.EncrdecrService.setEncr(res?.ReturnMessage));
                console.log(res?.ReturnMessage);
                this.OpenInternetBankingPage(res?.ReturnMessage);
                this.CallSuccessFailAlertModal(
                  "Your transaction has been initiated successfully. Kindly pay from the bank page opened in new window."
                );

              }
              else {
                this.CallSuccessFailAlertModal(
                  "Your transaction has been initiated successfully. Unable to open payment link."
                );
              }
            } else {
              this.CallSuccessFailAlertModal("Your transaction has been initiated successfully. Kindly authenticate the payment from your UPI App.")
            }
          }
        }, (err: any) => {
          this.Loader.hide();
          console.log(err);
        })
  }

  SuccessModel(msg: any) {
    // $("#SuccessBSEAlertModal").modal({ backdrop: "static", keyboard: false });
    const modal = new bootstrap.Modal(document.getElementById('SuccessBSEAlertModal'), {
      backdrop: 'static',
      keyboard: false
    });
    modal.show()
    if (msg.includes("<br/>")) {
      $("#SuccessBSEAlertModalContent").html(msg);
    } else {
      $("#SuccessBSEAlertModalContent").text(msg);
    }
  }
    ValidateUPIID(e) {
    debugger
    //
    
    if (e != "") {
      this.Loader.show()
      this.transaction.ValidateUPIID(e).then(result => {
        this.Loader.hide();
        let res = JSON.parse(this.EncrdecrService.getDecr(result));
        if (res.Message.toLowerCase().includes('not authorized')) {
          debugger
        }
        else {
          
          if (res.ArrayOfResponse.length > 0) {
            if (res.ArrayOfResponse[0].VALUEFIELD == 1) {
              this.UPIForm.controls["UPIID"].setErrors({ invalidUPI: true })

            } else {
              this.UPIForm.controls["UPIID"].setErrors(null);

            }
            this.Loader.hide();
          }
          else {
            this.Loader.hide();
            this.UPIForm.controls["UPIID"].setErrors(null);

          }
        }
      });

    }

  }

  //Siddhesh_23072026


}
